<template>
    <div style="position: relative;height: 100%;width: 100%">
        <div style="position: absolute;left: 3rem;bottom: 1rem;z-index: 10;" v-if="show.ztt === 'yqxx'">
            <div style="width: 120px;border: 1px solid #f5f5f5;border-radius: 4px;">
                <div style="width: 100%;height: 35px;background-color: #f7f7f7;text-align: center;line-height: 35px;font-size: 15px;">
                    面雨量(mm)
                </div>
                <div @click="mylShow" style="width: 100%;height: 45px;background-color: #fff;line-height: 45px;color: #4b7cf6;font-size: 15px;font-weight: 700;text-align: center;cursor: pointer;">
                    {{ mylData.drp }}
                </div>
            </div>
        </div>
        <div style="position: absolute;top: 5rem;left: 5rem;z-index: 10">
            <div style="background-color: #fbfbfb;border-radius: 13px 13px 0 0;height: 46px;width: 300px;font-weight: 600">
                <p style="font-size: 18px;line-height: 46px;color: #41427b;padding-left: 8px">{{ skName }}{{show.ztt === 'yqxx' ? '降雨量' : show.ztt === 'sqxx' ? '水情' : '安全'}}分布图</p>
            </div>
            <div style="background-color: #ffffff;border-radius: 0 0 13px 13px ;height: 46px;width: 300px;">
                <div style="font-size: 16px;line-height: 46px;color: #41427b;padding-left: 2px"> {{dataRange[0]}}至{{dataRange[1]}}</div>
            </div>
        </div>
        <div style="position: absolute;bottom: 0;left: 10%;z-index: 10">
            <img :src="show.ztt === 'yqxx' ? require('@/assets/yzt/tl.png') : show.ztt === 'sqxx' ? require('@/assets/yzt/tl_sqxx.png') : ''">
        </div>
        <img src="@/assets/yzt/jt_z.png" class="czjz pointer" v-if="show.right"
             style="transform: translate(-5%,-50%) rotate(180deg);left: calc(79.1% - 3rem);z-index: 9" @click="show.right = !show.right;czMap()"
        >
        <img src="@/assets/yzt/jt_y.png" class="czjz pointer"  v-if="!show.right"
             style="transform: translate(-5%,-50%) rotate(180deg);left: calc(100% - 3rem);z-index: 9" @click="show.right = !show.right;czMap()"
        >
        <el-row style="height: 100%;width: 100%;position: absolute;">
            <el-col :span="3" style="height: 100%;z-index: 2;">
                <img :src="show.left ? require('@/assets/yzt/jt_z.png') : require('@/assets/yzt/jt_y.png')" class="czjz pointer"
                     style="transform: translate(-5%,-50%);left: 0;z-index: 9" @click="show.left = !show.left"
                >
                <div class="ellipse" v-if="show.left" >
                    <img :src="show.ztt === 'yqxx' ? require('@/assets/yzt/yqxx_xz.png') : require('@/assets/yzt/yqxx.png')" @click="show.ztt = 'yqxx';getData();kzkz()" class="czjz pointer" style="top: 15%;left: 19rem">
                    <img :src="show.ztt === 'sqxx' ? require('@/assets/yzt/sqxx_xz.png') : require('@/assets/yzt/sqxx.png')" @click="show.ztt = 'sqxx';getData();kzkz()" class="czjz pointer" style="left: 22rem">
                    <img :src="show.ztt === 'aqxx' ? require('@/assets/yzt/aqxx_xz.png') : require('@/assets/yzt/aqxx.png')" @click="show.ztt = 'aqxx';initDataItem('jr');kzkz();" class="czjz pointer" style="top: 85%;left: 19rem">
                </div>
            </el-col>
            <el-col :offset="show.right  ? 0 : 5" :span="16" style="position: relative;height: 100%;top: 2rem">
                <!--散点、等值线、等值面-->
                <div class="dzxdzm" v-if="show.ztt == 'yqxx' &&  skCd === '65292330001'" :style="{width:show.ztt === 'yqxx' ? '299px' : '99px',marginRight:show.ztt === 'yqxx' ? '' : '200px'}">
                    <div class="pointer sdbutton" style="border-right: 1px solid #e8ecff"
                         :class="selectd.sdordzm === 'sd' ? 'buttonSeletd' : ''" @click="changeSdordzm('sd')">散点</div>
                    <div  class="pointer sdbutton" style="border-right: 1px solid #e8ecff"
                          :class="selectd.sdordzm === 'dzx' ? 'buttonSeletd' : ''" @click="changeSdordzm('dzx')">等值线</div>
                    <div v-if="show.ztt === 'yqxx'" class="pointer sdbutton"
                         :class="selectd.sdordzm === 'dzm' ? 'buttonSeletd' : ''" @click="changeSdordzm('dzm')">等值面</div>
                </div>
                <div v-if="show.ztt !== 'aqxx'">
                    <div class="tcSelect" v-if="selectd.sdordzm === 'sd'">
                        <div style="background-color: #3387e9;color:#fff;border-top-left-radius: 4px;border-top-right-radius: 4px;text-align: center;">
                            图层选择
                        </div>
                        <div class="tcSelectz">
                            <el-checkbox-group v-model="tcList" @change="tcChange">
                                <div>
                                    <el-checkbox label="测站" disabled></el-checkbox>
                                </div>
                                <div>
                                    <el-checkbox label="视频站"></el-checkbox>
                                </div>
                                <div>
                                    <el-checkbox label="图像站"></el-checkbox>
                                </div>
                            </el-checkbox-group>
                        </div>
                    </div>

                    <div class="marquee" style="position: absolute;bottom: 2%;right: 20px;width: 62rem;z-index: 10">
                        <div style="width: 100%" >
                            <div class="bs-sysMsg" v-if="tableList.length > 0">
                                <i class="el-alert__icon el-icon-warning"></i>
                                <div class="msg__content">
                                    <el-carousel height="20px" direction="vertical" :interval=5000 indicator-position="none" :autoplay="true">
                                        <el-carousel-item v-for="(item,index) in tableList" :key="index">
                                            <el-tooltip effect="light"  class="el-tooltip-omit">
                                                <div slot="content">
                                                    <div v-for="(item,index) in yjList">
                                                        <p>{{index+1+"、"+ item.nr }}</p>
                                                        <br v-if="index !== yjList.length -1"/>
                                                    </div>
                                                </div>
                                                <a href="javascript:void(0)"  title="点击跳转至预警信息界面" class="item" @click="toYjxx()">{{item.nr}}</a>-
                                            </el-tooltip>
                                        </el-carousel-item>
                                    </el-carousel>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="aqxxSelect" v-if="show.ztt === 'aqxx'" >

                    <div class="pointer sdbutton" v-for="(item,index) of aqxxItemList" style="border-right: 1px solid #e8ecff"
                         :style="{borderRight: index !== aqxxItemList.length -1 ? 'border-right: 1px solid #e8ecff' : ''}"
                         :class="selectd.aqxx ===  item.mstp ? 'buttonSeletd' : ''" @click="changeAqxxSelect(item.mstp)">{{item.mstpNm}}</div>
                    <!--                    <div class="pointer sdbutton" style="border-right: 1px solid #e8ecff"
                                             :class="selectd.aqxx === '0601' ? 'buttonSeletd' : ''" @click="changeAqxxSelect('0601')">测压管</div>
                                        <div  class="pointer sdbutton" style="border-right: 1px solid #e8ecff"
                                              :class="selectd.aqxx === '0602' ? 'buttonSeletd' : ''" @click="changeAqxxSelect('0602')">渗流计</div>
                                        <div class="pointer sdbutton" style="border-right: 1px solid #e8ecff"
                                             :class="selectd.aqxx === '0603' ? 'buttonSeletd' : ''" @click="changeAqxxSelect('0603')">应变</div>
                                        <div  class="pointer sdbutton" style="border-right: 1px solid #e8ecff"
                                             :class="selectd.aqxx === '0604' ? 'buttonSeletd' : ''" @click="changeAqxxSelect('0604')">水平位移X向</div>
                                        <div  class="pointer sdbutton" style="border-right: 1px solid #e8ecff"
                                             :class="selectd.aqxx === '0605' ? 'buttonSeletd' : ''" @click="changeAqxxSelect('0605')">水平位移Y向</div>
                                        <div  class="pointer sdbutton"
                                             :class="selectd.aqxx === '0606' ? 'buttonSeletd' : ''" @click="changeAqxxSelect('0606')">垂直位移</div>-->
                </div>
                <el-select v-if="show.ztt !== 'aqxx'" v-model="czValue" ref="mySelect" filterable remote
                           clearable reserve-keyword
                           :filter-method="queryCz"
                           @change="czChange"
                           style="width: 200px;position: absolute;right: 147px;z-index: 2 "
                           placeholder="输入站名/站码搜索"
                           @clear="qcqueryCz"
                >
                    <el-option
                        v-for="item in czOptions"
                        :key="item.stnm"
                        :label="item.lable"
                        :value="item.stnm"
                    >
                    </el-option>
                </el-select>
                <el-select v-else v-model="czValue" ref="mySelect" filterable remote
                           clearable reserve-keyword
                           :filter-method="queryCz"
                           @change="czChange"
                           style="width: 200px;position: absolute;right: 147px;z-index: 2 "
                           placeholder="输入测点搜索"
                           @clear="qcqueryCz"
                >
                    <el-option
                        v-for="item in czOptions"
                        :key="item.mpnm"
                        :label="item.lable"
                        :value="item.mpnm"
                    >
                    </el-option>
                </el-select>
                <el-tooltip effect="dark" content="回到中心点" placement="bottom">
                    <img src="@/assets/yzt/center.png"   style="position: absolute;z-index: 11;right: 76px;top: -2px;cursor: pointer" alt=""  @click="sxwz"/>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="工具" placement="right"  v-if="show.ztt !== 'aqxx'">
                    <img src="@/assets/yzt/tool.png" @click="show.tool = !show.tool" style="position: absolute;z-index: 11;right: 1rem;top: -2px;cursor: pointer" alt=""/>
                </el-tooltip>
                <div v-if="show.tool" style="position: absolute;width: 46px;height: calc(40vh + 7px);border-radius: 4px;z-index: 11;right: 1.4rem;top:60px;background-color: #ffffff">
                    <el-tooltip class="item" effect="dark" content="标点" placement="left">
                        <div style="position: relative;width: 46px;height: 5vh;border-bottom: 1px solid #e4e4e3;cursor:pointer;" @click="drawFeature('Point')">
                            <img src="@/assets/yzt/dw.png"  class="czjz" style="left:50%;top:50%" alt=""/>
                        </div>
                    </el-tooltip>

                    <el-tooltip class="item" effect="dark" content="标线" placement="left">
                        <div style="position: relative;width: 46px;height: 5vh;border-bottom: 1px solid #e4e4e3;cursor:pointer;"  @click="drawFeature('LineString')">
                            <img src="@/assets/yzt/toolbar_2.png" class="czjz" style="left:50%;top:50%" alt=""/>
                        </div>
                    </el-tooltip>
                    <el-tooltip class="item" effect="dark" content="标面" placement="left">
                        <div style="position: relative;width: 46px;height: 5vh;border-bottom: 1px solid #e4e4e3;cursor:pointer;" @click="drawFeature('Polygon')">
                            <img src="@/assets/yzt/toolbar_3.png" class="czjz" style="left:50%;top:50%" alt=""/>
                        </div>
                    </el-tooltip>
                    <el-tooltip class="item" effect="dark" content="画圆" placement="left">
                        <div style="position: relative;width: 46px;height: 5vh;border-bottom: 1px solid #e4e4e3;cursor:pointer;" @click="drawFeature('Circle')">
                            <img src="@/assets/yzt/toolbar_4.png" class="czjz" style="left:50%;top:50%" alt=""/>
                        </div>
                    </el-tooltip>
                    <el-tooltip class="item" effect="dark" content="画矩形" placement="left">
                        <div style="position: relative;width: 46px;height: 5vh;border-bottom: 1px solid #e4e4e3;cursor:pointer;"  @click="drawFeature('Box')">
                            <img src="@/assets/yzt/toolbar_5.png" class="czjz" style="left:50%;top:50%" alt=""/>
                        </div>
                    </el-tooltip>
                    <el-tooltip class="item" effect="dark" content="测距" placement="left">
                        <div style="position: relative;width: 46px;height: 5vh;border-bottom: 1px solid #e4e4e3;cursor:pointer;" @click="measure('distence')">
                            <img src="@/assets/yzt/toolbar_6.png" class="czjz" style="left:50%;top:50%" alt=""/>
                        </div>
                    </el-tooltip>
                    <el-tooltip class="item" effect="dark" content="测面" placement="left">
                        <div style="position: relative;width: 46px;height: 5vh;border-bottom: 1px solid #e4e4e3;cursor:pointer;" @click="measure('area')">
                            <img src="@/assets/yzt/toolbar_7.png" class="czjz" style="left:50%;top:50%" alt=""/>
                        </div>
                    </el-tooltip>
                    <el-tooltip class="item" effect="dark" content="清空" placement="left">
                        <div style="position: relative;width: 46px;height: 5vh;;cursor:pointer;"  @click="clearDrawLayer()">
                            <img src="@/assets/yzt/toolbar_8.png" class="czjz" style="left:50%;top:50%" alt=""/>
                        </div>
                    </el-tooltip>

                    <div style="position: relative;width: 46px;height: 12vh;background-color: #FFFFFF;top:70px;border-radius: 4px">
                        <el-tooltip class="item" effect="dark" content="放大" placement="left" >
                            <i class="el-icon-plus czjz" style="left:50%;top:25%;cursor: pointer" @click="zoomIn"></i>
                        </el-tooltip>
                        <div style="border-bottom: 1px solid #e4e4e3;position: relative;top:50%;"></div>
                        <el-tooltip class="item" effect="dark" content="缩小" placement="left" >
                            <i class="el-icon-minus czjz" style="left:50%;top:75%;cursor: pointer" @click="zoomOut"></i>
                        </el-tooltip>
                    </div>
                </div>

                <el-row  style="margin: 0;position: absolute;top:50px;z-index: 2;width: 32rem;right: 1rem;" v-if="zgData.length>0" >
                    <el-col :span="24" v-for="(item,index) in zgData" :key="index" style="margin-top: 10px;">
                        <div style="border: 1px solid #53abfd;background-color: #53abfd;	border-radius: 6px;">
                            <div style="color: #fff;font-size: 14px;width: 100%;height: 30px;line-height: 30px;text-align: center;">
                                <span>{{ item.tmGE }}</span>
                                <span>到</span>
                                <span>{{ item.tmLE }}</span>
                            </div>
                            <div style="height: 40px;background-color: #fff;line-height: 40px;font-size: 14px;font-weight: 700;	border-radius: 6px;">
                                <span style="padding-left: 1rem;">{{ item.stnm }}</span>
                                <div style="float: right;padding-right: 1rem">
                                    <span style="color: #323232;">雨量：</span>
                                    <span style="color: #1ba57a;">{{ item.maxDrp }}</span>
                                    <span style="color: #323232;">mm</span>
                                </div>

                            </div>
                        </div>
                    </el-col>
                </el-row>
            </el-col>
            <el-col :span="5" v-show="show.right" style="position: relative;height: 100%;background: #fff;border-radius: 8px;padding:10px;z-index: 2;">
                <el-row>
                    <el-col :span="6">  <span style="color: #41427b;font-size: 2rem;font-weight: 600;line-height: 5rem">选择时间</span></el-col>
                    <el-col :span="18" style="background-color: #F7F7F7;height: 5rem;border-radius: 6px;align-items: center;display: flex;">
                        <span style="font-size: 1.8rem;padding:0 0.5rem">间隔</span>
                        <el-dropdown  @command="handleCommand" >
                            <el-button style="height: 3.5rem;padding:2px;font-size: 1.7rem;background-color: #FFFFFF;border-radius: 4px;border: solid 1px #FFFFFF;color: #143D6E;">
                                {{ sjcommand }}
                                <i class="el-icon-arrow-down el-icon--right"></i>
                            </el-button>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item command="1分钟">1分钟</el-dropdown-item>
                                <el-dropdown-item command="3分钟">3分钟</el-dropdown-item>
                                <el-dropdown-item command="5分钟">5分钟</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
<!--                        <span style="padding:0 2rem">
                            <div style="font-size: 1.4rem">距下次刷新</div>
                             <div style="text-align: center;font-size: 1.6rem">{{mins}}分{{seconds}}秒</div>
                        </span>-->
                        <span style="font-size: 1.5rem;">
                            距下次刷新
                        </span>
                        <span style="font-size: 1.5rem;padding: 0 0.5rem">
                           {{mins}}分{{seconds}}秒
                        </span>
                        <div >
                            <el-tooltip class="item" effect="dark" content="点击刷新" placement="top-start">
                                <img src="@/assets/yzt/refresh.png" style="cursor:pointer;float:right" @click="deadline === 0;getTime(deadline);componentTimerFun()"/>
                            </el-tooltip>

                        </div>
                    </el-col>
                </el-row>

                <div style="padding-top: 10px;height: 3rem" ref="aqxxTable">
                    <div style="float: left;font-size: 18px;line-height: 40px" v-if="show.ztt === 'yqxx' || show.ztt === 'sqxx' ">最近:</div>
                    <div class="xzsj1" v-if="show.ztt === 'yqxx' || show.ztt === 'sqxx' ">
                        <div class="pointer sjbutton1"
                             :class="selectd.sjxz1 === 'yxs' ? 'buttonSeletd' : ''" @click="changeSjxz1('yxs')">1小时</div>
                        <div class="pointer sjbutton1"
                             :class="selectd.sjxz1 === 'sxs' ? 'buttonSeletd' : ''" @click="changeSjxz1('sxs')">3小时</div>
                        <div class="pointer sjbutton1"
                             :class="selectd.sjxz1 === 'lxs' ? 'buttonSeletd' : ''" @click="changeSjxz1('lxs')">6小时</div>
                        <div class="pointer sjbutton1"
                             :class="selectd.sjxz1 === 'sexs' ? 'buttonSeletd' : ''" @click="changeSjxz1('sexs')">12小时</div>
                        <div class="pointer sjbutton1"
                             :class="selectd.sjxz1 === 'esxs' ? 'buttonSeletd' : ''" @click="changeSjxz1('esxs')">24小时</div>
                        <!--                        <div class="pointer sjbutton1"-->
                        <!--                             :class="selectd.sjxz1 === 'jr' ? 'buttonSeletd' : ''" @click="changeSjxz1('jr')">今日</div>-->
                        <!--                        <div class="pointer sjbutton1"-->
                        <!--                             :class="selectd.sjxz1 === 'zr' ? 'buttonSeletd' : ''" @click="changeSjxz1('zr')">昨日</div>-->
                    </div>
                    <div class="xzsj2" style="margin-top: 10px;">
                        <div class="pointer sjbutton2"
                             :class="selectd.sjxz1 === 'jr' ? 'buttonSeletd' : 'sjbutton2'" @click="changeSjxz1('jr')">今日8:00至现在</div>
                        <div class="pointer sjbutton2" style="margin-left: 10px"
                             :class="selectd.sjxz1 === 'zr' ? 'buttonSeletd' : 'sjbutton2'" @click="changeSjxz1('zr')">昨日8:00至今日8:00</div>
                    </div>
                </div>

                <div style="padding-top: 20px">
                    <div style="width: 100%;overflow:auto;margin-top: 60px">
                        <el-table v-if="show.ztt === 'yqxx'" :data="tableData"  style="overflow:auto;border: solid 1px #e4e4e4;" :header-cell-style="{background:'#f7f7f7',fontWeight: 500}"
                                  height="calc(100vh - 450px)" width="calc(100% - 2px)" :span-method="arraySpanMethod"
                                  :row-class-name="iconHadler" :cell-style="cellStyle" class="myrow"
                                  header-align="center" size="small">
                            <el-table-column width="70" prop="stcd" label="编号" align="left">
                                <template  slot-scope="scope">
                                    <div v-show="scope.row.label === 1 && scope.row.length > 0">
                                        <!--                                        <div v-if="scope.row.id === 1" style="color: #ffffff;background-color:#FF1010" >-->
                                        <!--                                            <img src="@/assets/yzt/rightbutton.png" style="cursor: pointer;margin-left: 5px">-->
                                        <!--                                            {{scope.row.name}}<span style="float: right;margin-right: 2rem">{{scope.row.length}}</span>-->
                                        <!--                                        </div>-->

                                        <div v-if="scope.row.id === 1 " style="color: #ffffff;background-color:#9A435E" >
                                            <img :src="show.table.extremelyHeavyRainstorm ? require('@/assets/yzt/xlbutton.png') : require('@/assets/yzt/rightbutton.png')"
                                                 @click="show.table.extremelyHeavyRainstorm = !show.table.extremelyHeavyRainstorm && scope.row.length > 0"   style="cursor: pointer;margin-left: 5px">
                                            {{scope.row.name}}<span style="float: right;margin-right: 2rem">{{scope.row.length}}个</span>
                                        </div>
                                        <div v-if="scope.row.id === 1 && show.table.extremelyHeavyRainstorm" >
                                            <el-row  class="myrow" v-for="(item,index) in scope.row.children" :key="index" :style="{background:row.stcd === rowCheck ? '#ECF5FF' : ( index % 2 === 1 ? '#fbfbfb' : '')}" style="font-size: 1.5rem;height: 4rem;line-height: 4rem">
                                                <div @click="clickData(item,index)">
                                                    <el-col :span="8" style="text-align: center;cursor: pointer;color: #46adf5">
                                                        <div v-if="item.stnm.length > 10" @click.stop="clickJcz(item)">
                                                            <el-tooltip class="item" effect="dark" :content="item.stnm" placement="right-start">
                                                                {{item.stcd.slice(0,2)+".."+item.stcd.slice(-2)}}
                                                            </el-tooltip>
                                                        </div>
                                                        <div v-else @click.stop="clickJcz(item)" >
                                                            {{item.stcd}}
                                                        </div>
                                                    </el-col>
                                                    <el-col :span="10">
                                                        <div v-if="item.stnm.length > 7">
                                                            <el-tooltip class="item" effect="dark" :content="item.stnm" placement="right-start">
                                                                <span>
                                                                        {{item.stnm.slice(0,2)+".."+item.stnm.slice(-2)}}
                                                                </span>
                                                            </el-tooltip>
                                                        </div>
                                                        <div v-else>
                                                            <span>
                                                                {{item.stnm}}
                                                            </span>
                                                        </div>
                                                    </el-col>
                                                    <el-col :span="6" style="text-align: right;padding-right: 1rem"><span>{{item.totalRain}}</span></el-col>
                                                </div>
                                            </el-row>
                                        </div>
                                        <div v-if="scope.row.id === 2 " style="color: #ffffff;background-color:#EA33F1" >
                                            <img :src="show.table.heavyRainstorm ? require('@/assets/yzt/xlbutton.png') : require('@/assets/yzt/rightbutton.png')"
                                                 @click="show.table.heavyRainstorm = !show.table.heavyRainstorm && scope.row.length > 0"   style="cursor: pointer;margin-left: 5px">
                                            {{scope.row.name}}<span style="float: right;margin-right: 2rem">{{scope.row.length}}个</span>
                                        </div>
                                        <div v-if="scope.row.id === 2 && show.table.heavyRainstorm" >
                                            <el-row  class="myrow" v-for="(item,index) in scope.row.children" :key="index" :style="{background:item.stcd === rowCheck ? '#ECF5FF' : ( index % 2 === 1 ? '#fbfbfb' : '')}" style="font-size: 1.5rem;height: 4rem;line-height: 4rem">
                                                <div @click="clickData(item,index)">
                                                    <el-col :span="8" style="text-align: center;cursor: pointer;color: #46adf5">
                                                        <div v-if="item.stnm.length > 10" @click.stop="clickJcz(item)" >
                                                            <el-tooltip class="item" effect="dark" :content="item.stnm" placement="right-start">
                                                                {{item.stcd.slice(0,2)+".."+item.stcd.slice(-2)}}
                                                            </el-tooltip>
                                                        </div>
                                                        <div v-else @click.stop="clickJcz(item)">
                                                            {{item.stcd}}
                                                        </div>
                                                    </el-col>
                                                    <el-col :span="10">
                                                        <div v-if="item.stnm.length > 7">
                                                            <el-tooltip class="item" effect="dark" :content="item.stnm" placement="right-start">
                                                                <span>
                                                                        {{item.stnm.slice(0,2)+".."+item.stnm.slice(-2)}}
                                                                </span>
                                                            </el-tooltip>
                                                        </div>
                                                        <div v-else>
                                                            <span>
                                                                {{item.stnm}}
                                                            </span>
                                                        </div>
                                                    </el-col>
                                                    <el-col :span="6" style="text-align: right;padding-right: 1rem"><span>{{item.totalRain}}</span></el-col>
                                                </div>
                                            </el-row>
                                        </div>

                                        <div v-if="scope.row.id === 3" style="color: #ffffff;background-color:#0104F2" >
                                            <img :src="show.table.rainstorm ? require('@/assets/yzt/xlbutton.png') : require('@/assets/yzt/rightbutton.png')"
                                                 @click="show.table.rainstorm = !show.table.rainstorm && scope.row.length > 0"   style="cursor: pointer;margin-left: 5px">
                                            {{scope.row.name}}<span style="float: right;margin-right: 2rem">{{scope.row.length}}个</span>
                                        </div>
                                        <div v-if="scope.row.id === 3 && show.table.rainstorm">
                                            <el-row  class="myrow" v-for="(item,index) in scope.row.children" :key="index" :style="{background:item.stcd === rowCheck ? '#ECF5FF' : ( index % 2 === 1 ? '#fbfbfb' : '')}" style="font-size: 1.5rem;height: 4rem;line-height: 4rem">
                                                <div @click="clickData(item,index)">
                                                    <el-col :span="8" style="text-align: center;cursor: pointer;color: #46adf5">
                                                        <div v-if="item.stnm.length > 10" @click.stop="clickJcz(item)">
                                                            <el-tooltip class="item" effect="dark" :content="item.stnm" placement="right-start">
                                                                {{item.stcd.slice(0,2)+".."+item.stcd.slice(-2)}}
                                                            </el-tooltip>
                                                        </div>
                                                        <div v-else @click.stop="clickJcz(item)">
                                                            {{item.stcd}}
                                                        </div>
                                                    </el-col>
                                                    <el-col :span="10">
                                                        <div v-if="item.stnm.length > 7">
                                                            <el-tooltip class="item" effect="dark" :content="item.stnm" placement="right-start">
                                                                <span>
                                                                        {{item.stnm.slice(0,2)+".."+item.stnm.slice(-2)}}
                                                                </span>
                                                            </el-tooltip>
                                                        </div>
                                                        <div v-else>
                                                            <span>
                                                                {{item.stnm}}
                                                            </span>
                                                        </div>
                                                    </el-col>
                                                    <el-col :span="6" style="text-align: right;padding-right: 1rem"><span>{{item.totalRain}}</span></el-col>
                                                </div>
                                            </el-row>
                                        </div>

                                        <div v-if="scope.row.id === 4" style="color: #ffffff;background-color:#5BB9F9" >
                                            <img :src="show.table.heavyRain ? require('@/assets/yzt/xlbutton.png') : require('@/assets/yzt/rightbutton.png')"
                                                 @click="show.table.heavyRain = !show.table.heavyRain && scope.row.length > 0"   style="cursor: pointer;margin-left: 5px">
                                            {{scope.row.name}}<span style="float: right;margin-right: 2rem">{{scope.row.length}}个</span>
                                        </div>
                                        <div v-if="scope.row.id === 4 && show.table.heavyRain">
                                            <el-row  class="myrow" v-for="(item,index) in scope.row.children" :key="index" :style="{background:item.stcd === rowCheck ? '#ECF5FF' : ( index % 2 === 1 ? '#fbfbfb' : '')}" style="font-size: 1.5rem;height: 4rem;line-height: 4rem">
                                                <div @click="clickData(item,index)">
                                                    <el-col :span="8" style="text-align: center;cursor: pointer;color: #46adf5">
                                                        <div v-if="item.stnm.length > 10" @click.stop="clickJcz(item)">
                                                            <el-tooltip class="item" effect="dark" :content="item.stnm" placement="right-start">
                                                                {{item.stcd.slice(0,2)+".."+item.stcd.slice(-2)}}
                                                            </el-tooltip>
                                                        </div>
                                                        <div v-else @click.stop="clickJcz(item)">
                                                            {{item.stcd}}
                                                        </div>
                                                    </el-col>
                                                    <el-col :span="10">
                                                        <div v-if="item.stnm.length > 7">
                                                            <el-tooltip class="item" effect="dark" :content="item.stnm" placement="right-start">
                                                                <span>
                                                                        {{item.stnm.slice(0,2)+".."+item.stnm.slice(-2)}}
                                                                </span>
                                                            </el-tooltip>
                                                        </div>
                                                        <div v-else>
                                                            <span>
                                                                {{item.stnm}}
                                                            </span>
                                                        </div>
                                                    </el-col>
                                                    <el-col :span="6" style="text-align: right;padding-right: 1rem"><span>{{item.totalRain}}</span></el-col>
                                                </div>
                                            </el-row>
                                        </div>

                                        <div v-if="scope.row.id === 5" style="color: #ffffff;background-color:#4CA93B" >
                                            <img :src="show.table.moderateRain ? require('@/assets/yzt/xlbutton.png') : require('@/assets/yzt/rightbutton.png')"
                                                 @click="show.table.moderateRain = !show.table.moderateRain && scope.row.length > 0"   style="cursor: pointer;margin-left: 5px">
                                            {{scope.row.name}}<span style="float: right;margin-right: 2rem">{{scope.row.length}}个</span>
                                        </div>
                                        <div v-if="scope.row.id === 5 && show.table.moderateRain">
                                            <el-row  class="myrow" v-for="(item,index) in scope.row.children" :key="index" :style="{background:item.stcd === rowCheck ? '#ECF5FF' : ( index % 2 === 1 ? '#fbfbfb' : '')}" style="font-size: 1.5rem;height: 4rem;line-height: 4rem">
                                                <div @click="clickData(item,index)">
                                                    <el-col :span="8" style="text-align: center;cursor: pointer;color: #46adf5">
                                                        <div v-if="item.stnm.length > 10" @click.stop="clickJcz(item)" >
                                                            <el-tooltip class="item" effect="dark" :content="item.stnm" placement="right-start">
                                                                {{item.stcd.slice(0,2)+".."+item.stcd.slice(-2)}}
                                                            </el-tooltip>
                                                        </div>
                                                        <div v-else @click.stop="clickJcz(item)">
                                                            {{item.stcd}}
                                                        </div>
                                                    </el-col>
                                                    <el-col :span="10">
                                                        <div v-if="item.stnm.length > 7">
                                                            <el-tooltip class="item" effect="dark" :content="item.stnm" placement="right-start">
                                                                <span>
                                                                        {{item.stnm.slice(0,2)+".."+item.stnm.slice(-2)}}
                                                                </span>
                                                            </el-tooltip>
                                                        </div>
                                                        <div v-else>
                                                            <span>
                                                                {{item.stnm}}
                                                            </span>
                                                        </div>
                                                    </el-col>
                                                    <el-col :span="6" style="text-align: right;padding-right: 1rem"><span>{{item.totalRain}}</span></el-col>
                                                </div>
                                            </el-row>
                                        </div>

                                        <div v-if="scope.row.id === 6" style="color: #ffffff;background-color:#A2F29D" >
                                            <img :src="show.table.lightRain ? require('@/assets/yzt/xlbutton.png') : require('@/assets/yzt/rightbutton.png')"
                                                 @click="show.table.lightRain = !show.table.lightRain && scope.row.length > 0"   style="cursor: pointer;margin-left: 5px">
                                            {{scope.row.name}}<span style="float: right;margin-right: 2rem">{{scope.row.length}}个</span>
                                        </div>
                                        <div v-if="scope.row.id === 6 && show.table.lightRain" >
                                            <el-row class="myrow"  v-for="(item,index) in scope.row.children" :key="index" :style="{background:item.stcd === rowCheck ? '#ECF5FF' : ( index % 2 === 1 ? '#fbfbfb' : '')}"   style="font-size: 1.5rem;height: 4rem;line-height: 4rem">
                                                <div @click="clickData(item,index)"  >
                                                    <el-col :span="8" style="text-align: center;cursor: pointer;color: #46adf5">
                                                        <div v-if="item.stnm.length > 10"  @click.stop="clickJcz(item)" >
                                                            <el-tooltip class="item" effect="dark" :content="item.stnm" placement="right-start">
                                                                {{item.stcd.slice(0,2)+".."+item.stcd.slice(-2)}}
                                                            </el-tooltip>
                                                        </div>
                                                        <div v-else  @click.stop="clickJcz(item)" >
                                                            {{item.stcd}}
                                                        </div>
                                                    </el-col>
                                                    <el-col :span="10">
                                                        <div v-if="item.stnm.length > 7">
                                                            <el-tooltip class="item" effect="dark" :content="item.stnm" placement="right-start">
                                                                <span>
                                                                        {{item.stnm.slice(0,2)+".."+item.stnm.slice(-2)}}
                                                                </span>
                                                            </el-tooltip>
                                                        </div>
                                                        <div v-else>
                                                            <span>
                                                                {{item.stnm}}
                                                            </span>
                                                        </div>
                                                    </el-col>
                                                    <el-col :span="6" style="text-align: right;padding-right: 1rem"><span>{{item.totalRain}}</span></el-col>
                                                </div>
                                            </el-row>
                                        </div>

                                        <div v-if="scope.row.id === 7" style="color: #4b4b4b;background-color:#dddddd" >
                                            <img :src="show.table.noRain ? require('@/assets/yzt/xlbutton.png') : require('@/assets/yzt/rightbutton.png')"
                                                 @click="show.table.noRain = !show.table.noRain && scope.row.length > 0"   style="cursor: pointer;margin-left: 5px">
                                            {{scope.row.name}}<span style="float: right;margin-right: 2rem">{{scope.row.length}}个</span>
                                        </div>
                                        <div v-if="scope.row.id === 7 && show.table.noRain" >
                                            <el-row class="myrow"  v-for="(item,index) in scope.row.children" :key="index" :style="{background:item.stcd === rowCheck ? '#ECF5FF' : ( index % 2 === 1 ? '#fbfbfb' : '')}"   style="font-size: 1.5rem;height: 4rem;line-height: 4rem">
                                                <div @click="clickData(item,index)"  >
                                                    <el-col :span="8" style="text-align: center;cursor: pointer;color: #46adf5">
                                                        <div v-if="item.stnm.length > 10"  @click.stop="clickJcz(item)" >
                                                            <el-tooltip class="item" effect="dark" :content="item.stnm" placement="right-start">
                                                                {{item.stcd.slice(0,2)+".."+item.stcd.slice(-2)}}
                                                            </el-tooltip>
                                                        </div>
                                                        <div v-else  @click.stop="clickJcz(item)" >
                                                            {{item.stcd}}
                                                        </div>
                                                    </el-col>
                                                    <el-col :span="10">
                                                        <div v-if="item.stnm.length > 7">
                                                            <el-tooltip class="item" effect="dark" :content="item.stnm" placement="right-start">
                                                                <span>
                                                                        {{item.stnm.slice(0,2)+".."+item.stnm.slice(-2)}}
                                                                </span>
                                                            </el-tooltip>
                                                        </div>
                                                        <div v-else>
                                                            <span>
                                                                {{item.stnm}}
                                                            </span>
                                                        </div>
                                                    </el-col>
                                                    <el-col :span="6" style="text-align: right;padding-right: 1rem"><span>{{item.totalRain}}</span></el-col>
                                                </div>
                                            </el-row>
                                        </div>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column width="90" prop="z" label="站名" align="right"></el-table-column>
                            <el-table-column prop="z" label="累计雨量（mm）" align="right">
                                <template  slot-scope="scope">
                                    <div v-if="scope.row.label === 1">
                                        <span>{{scope.row.length}}</span>
                                    </div>
                                    <div v-else> <span>-</span></div>
                                </template>
                            </el-table-column>
                        </el-table>
                        <!--水情信息table-->
                        <div v-if="show.ztt === 'sqxx'" style="">
                            <div style="background-color: #f7f7f7;border-radius: 4px 4px 0 0;height: 46px;width: 100%;">
                                <p style="font-size: 18px;line-height: 46px;color: #41427b;padding-left: 1.5rem;font-weight: 600">水库水情</p>
                            </div>
                            <div  @click="clickData(tableData2)" >
                                <el-row class="myrow" :style="{background:sksqCheckd ? '#F5F7FA' : '#ffffff'}" style="border-radius: 0 0 4px 4px ;border: solid 1px #e4e4e4;font-size: 1.5rem;line-height: 40px;padding:1rem;cursor: pointer ">
                                    <el-row style="height: 4rem">
                                        <el-col :span="9" style="height: 4rem">
                                            <el-col :span="9" style="color: #3c3c3c;display: flex;justify-content: flex-end;">站<span style="padding-left: 1.2rem"></span>名:</el-col>
                                            <el-col :span="15" style="color: #41427b;">
                                                <div v-if="tableData2.stnm ? tableData2.stnm.length > 7 : false">
                                                    <el-tooltip class="item" effect="dark" :content="tableData2.stcd+'/'+tableData2.stnm" placement="top-start">
                                                       <span >
                                                            {{ tableData2.stnm.slice(0,2)+"..."+ tableData2.stnm.slice(-2)}}
                                                       </span>
                                                    </el-tooltip>
                                                </div>
                                                <div v-else>
                                                <span >
                                                    {{ tableData2.stnm.slice(0,2)+".."+ tableData2.stnm.slice(-2)}}
                                               </span>
                                                </div>
                                            </el-col>
                                        </el-col>
                                        <el-col :span="15" >
                                            <el-col :span="8" style="color: #3c3c3c;display: flex;justify-content: flex-end;">时<span style="padding-left: 1.2rem"></span>间:</el-col>
                                            <el-col :span="16" style="color: #41427b;">
                                                <div v-if="tableData2.tm ">
                                                    {{  tableData2.tm.slice(0,20)}}
<!--                                                    <el-tooltip class="item" effect="dark" :content=" tableData2.tm" placement="top-start">
                                                       <span >
                                                         {{  tableData2.tm.slice(0,20)}}
                                                       </span>
                                                    </el-tooltip>-->
                                                </div>
                                                <div v-else>
                                                <span >
                                                    -
                                               </span>
                                                </div>
                                            </el-col>
                                        </el-col>
                                    </el-row>
                                    <el-row style="height: 4rem">
                                        <el-col :span="9" style="padding-left: 2px">
                                            <el-col :span="9" style="color: #3c3c3c;display: flex;justify-content: flex-end;">库水位:</el-col>
                                            <el-col :span="15" style="color: #41427b;">{{ tableData2.rz ? tableData2.rz : ' - '}}m</el-col>
                                        </el-col>
                                        <el-col :span="15" >
                                            <el-col :span="8" style="color: #3c3c3c;display: flex;justify-content: flex-end;">蓄水量:</el-col>
                                            <el-col :span="16" style="color: #41427b;">{{ tableData2.w ? tableData2.w : ' - '}}(10⁴m³)</el-col>
                                        </el-col>
                                    </el-row>
                                    <el-row style="height: 4rem">
                                        <el-col :span="9" style="padding-left: 2px">
                                            <el-col :span="9" style="color: #3c3c3c;display: flex;justify-content: flex-end;">入<span style="padding-left: 1.2rem"></span>库:</el-col>
                                            <el-col :span="15" style="color: #41427b;">{{ tableData2.inboundFlow ? tableData2.inboundFlow : ' - '}}m/s</el-col>
                                        </el-col>
                                        <el-col :span="15" >
                                            <el-col :span="8" style="color: #3c3c3c;display: flex;justify-content: flex-end;">出<span style="padding-left: 1.2rem"></span>库:</el-col>
                                            <el-col :span="16" style="color: #41427b;">{{ tableData2.outboundFlow ? tableData2.outboundFlow : ' - '}}m/s</el-col>
                                        </el-col>
                                    </el-row>
                                </el-row>

                            </div>
                         </div>
                        <div v-if="show.ztt === 'sqxx'" style="padding-top: 0.5rem">
                            <div style="background-color: #f7f7f7;border-radius: 4px 4px 0 0;height: 46px;width: 100%;">
                                <p style="font-size: 18px;line-height: 46px;color: #41427b;padding-left: 1.5rem;font-weight: 600">河道水情</p>
                            </div>
                            <el-table  :data="tableData3"  style="overflow:auto;border: solid 1px #e4e4e4;" :header-cell-style="{background:'#f7f7f7',fontWeight: 500}"
                                      height="calc(100vh - 690px)" width="calc(100% - 2px)" :key="table3Key"
                                      :cell-style="cellStyle"  :row-class-name="tableRowClassName"
                                      header-align="center" size="small" :highlight-current-row="tableRowCheck"
                                      @row-click="clickData"
                            >
                                <el-table-column width="100" prop="stcd" label="站名" :show-overflow-tooltip="true" align="center">
                                    <template slot-scope="scope">
                                        <div  @click.stop="clickJcz(scope.row)">
                                            <el-tooltip class="item" effect="dark" :content="scope.row.stcd+'/'+scope.row.stnm" placement="top-start">
                                               <span style="cursor: pointer;color: #46adf5">
                                                    {{ scope.row.stnm.slice(0,2)+"..."+ scope.row.stnm.slice(-2)}}
                                               </span>
                                            </el-tooltip>
                                        </div>
<!--                                        <span style="cursor: pointer;color: #46adf5" @click.stop="clickJcz(scope.row)">{{ scope.row.stcd }}</span>-->
                                    </template>
                                </el-table-column>
                                <el-table-column prop="tm" label="时间" width="180" align="center">
                                </el-table-column>
<!--                                <el-table-column prop="stnm" label="站名" :show-overflow-tooltip="true" align="center">
                                </el-table-column>-->
                                <el-table-column prop="z" width="80" label="水位(m)" align="right">
                                    <template  slot-scope="scope">
                                        <div v-if="scope.row.trend === 1" style="color:#fd1553 ">
                                            <span>{{scope.row.z}}</span>
                                        </div>
                                        <div v-if="scope.row.trend === 0" style="color:#15bffd ">
                                            <span>{{scope.row.z}}</span>
                                        </div>
                                        <div v-if="scope.row.trend === -1" >
                                            <span>{{scope.row.z}}</span>
                                        </div>
                                    </template>
                                </el-table-column>

                                <el-table-column prop="q"  width="100" label="流量(m³/s)" align="right">
                                </el-table-column>
                            </el-table>
                        </div>
                        <div v-if="show.ztt === 'aqxx'" style="padding-top: 0.5rem">
                            <el-table class="aqxx-table" :data="tableData4" max-height="calc(100vh - 450px)"	 style="overflow:auto;border: solid 1px #e4e4e4;"
                                      :header-cell-style="{background:'#f7f7f7',fontWeight: 500}"
                                      height="calc(100vh - 450px)" width="calc(100% - 2px)"
                                      :cell-style="cellStyle"  :row-class-name="tableRowClassName"
                                      header-align="center" size="small" ref="tableRef"
                                      @row-click="handleAqxxRowClick" :highlight-current-row="tableRowCheck"
                            >
                                <el-table-column width="130" prop="mpcd" label="测点编号" :show-overflow-tooltip="true" align="center">
                                    <template slot-scope="scope">
                                        <span @click.stop="onAqxxRowClick(scope.row)" style="cursor: pointer;color: #46adf5">{{scope.row.mpcd}}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="mstm"  width="175" label="时间" :show-overflow-tooltip="true" align="center">
                                </el-table-column>
                                <el-table-column v-if="selectd.aqxx === '0601'" prop="pztbwl" width="80" label="测压管水位(m)" align="right">
                                    <template slot-scope="scope">
                                        <div v-if="scope.row.trend === 1" style="color:#fd1553 ">
                                            <span>{{scope.row.pztbwl}}</span>
                                        </div>
                                        <div v-if="scope.row.trend === 0" style="color:#15bffd ">
                                            <span>{{scope.row.pztbwl}}</span>
                                        </div>
                                        <div v-if="scope.row.trend === -1" >
                                            <span>{{scope.row.pztbwl}}</span>
                                        </div>
                                    </template>

                                </el-table-column>
                                <el-table-column v-if="selectd.aqxx === '0602'" prop="spprwl" width="80" label="渗流压力水位(m)" align="right">
                                    <template slot-scope="scope">
                                        <div v-if="scope.row.trend === 1" style="color:#fd1553 ">
                                            <span>{{scope.row.spprwl}}</span>
                                        </div>
                                        <div v-if="scope.row.trend === 0" style="color:#15bffd ">
                                            <span>{{scope.row.spprwl}}</span>
                                        </div>
                                        <div v-if="scope.row.trend === -1" >
                                            <span>{{scope.row.spprwl}}</span>
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column v-if="selectd.aqxx === '0603'" prop="stn"  :show-overflow-tooltip="true" width="80" label="应变(10^(-6))" align="right">
                                    <template slot-scope="scope">
                                        <div v-if="scope.row.trend === 1" style="color:#fd1553 ">
                                            <span>{{scope.row.stn}}</span>
                                        </div>
                                        <div v-if="scope.row.trend === 0" style="color:#15bffd ">
                                            <span>{{scope.row.stn}}</span>
                                        </div>
                                        <div v-if="scope.row.trend === -1" >
                                            <span>{{scope.row.stn}}</span>
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column v-if="selectd.aqxx === '0601'" prop="rwater" width="80" label="实际水深（m）" align="right">
                                </el-table-column>
                                <el-table-column  v-if="selectd.aqxx === '0604'" prop="xhrds" width="190"  label="X向水平位移（mm）" align="right">
                                    <template slot-scope="scope">
                                        <div :style="{ color: aqxxTrendColor(scope.row.xtrend) }">
                                            <span>{{scope.row.xhrds}}</span>
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column  v-if="selectd.aqxx === '0605'" prop="yhrds" width="190"  label="Y向水平位移（mm）" align="right">
                                    <template slot-scope="scope">
                                        <div :style="{ color: aqxxTrendColor(scope.row.ytrend) }">
                                            <span>{{scope.row.yhrds}}</span>
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column  v-if="selectd.aqxx === '0606'" prop="vrds" width="190" label="垂直位移（mm）" align="right">
                                    <template slot-scope="scope">
                                        <div v-if="scope.row.trend === 1" style="color:#fd1553 ">
                                            <span>{{scope.row.vrds}}</span>
                                        </div>
                                        <div v-if="scope.row.trend === 0" style="color:#15bffd ">
                                            <span>{{scope.row.vrds}}</span>
                                        </div>
                                        <div v-if="scope.row.trend === -1" >
                                            <span>{{scope.row.vrds}}</span>
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column  v-if="!selectd.aqxx === '0604' || !selectd.aqxx === '0605' || !selectd.aqxx === '0606'"
                                                  prop="wt" width="70" label="温度（°C）" align="right">
                                </el-table-column>
                                <el-table-column   v-if="selectd.aqxx === '0601' || selectd.aqxx === '0602' || selectd.aqxx === '0603'" prop="wt" width="70" label="温度（°C）" align="right">
                                </el-table-column>
                            </el-table>
                        </div>
                    </div>
                </div>

                <div style="height: 2rem;margin-top: 10px;background-color: #fbfbfb"></div>

                <div style="margin-top: 10px;">
                    <div style="color: #41427b;font-size: 2rem;font-weight: 600">测站状态</div>
                    <el-row style="padding-top: 20px;" >
                        <el-col :span="8" >
                            <img src="@/assets/yzt/qbsb.png" style="float: left">
                            <div style="font-size: 1.5rem;color: #41427b;text-align: center" >全部设备</div>
                            <div style="font-size: 2rem;color: #41427b;padding-top: 5px;text-align: center" >{{czStatus.totalNum}}</div>
                        </el-col>
                        <el-col :span="8" >
                            <img src="@/assets/yzt/zcsb.png" style="float: left">
                            <div style="font-size: 1.5rem;color: #41427b;text-align: center" >正常设备</div>
                            <div style="font-size: 2rem;color: #41427b;padding-top: 5px;text-align: center" >{{czStatus.normaNum}}</div>
                        </el-col>
                        <el-col :span="8" >
                            <img src="@/assets/yzt/ycsb.png" style="float: left">
                            <div style="font-size: 1.5rem;color: #41427b;text-align: center" >异常设备</div>
                            <div style="font-size: 2rem;color: #41427b;padding-top: 5px;text-align: center" >{{czStatus.abnormalNum}}</div>
                        </el-col>
                    </el-row>
                </div>
            </el-col>
        </el-row>
        <div v-show="selectd.sdordzm !== 'sd' " style="position: relative;z-index: 11;background-color: #3a8ee6;height: 100%;width: 100%">
            <screen_dzm ref="screen_dzm" />
        </div>


        <!-- 雨水情弹出框 -->
        <rainOpen :rainCz="rainCz" ref="rainChildren"></rainOpen>
        <riverOpen :riverCz="riverCz" ref="riverChildren"></riverOpen>
        <rsvrOpen :rsvrCz="rsvrCz" ref="rsvrChildren"></rsvrOpen>
        <mylOpen :mylCz="mylCz" ref="mylChildren"></mylOpen>
        <!-- 安全信息弹出框 -->
        <monitor-detail ref="aqxxDetail" style="width: 100%"></monitor-detail>
        <div class="map"  ref="aqxxMap" id="aqxxMap" v-show="show.ztt === 'aqxx'">
            <point-detail  ref="aqxxPointDetail" ></point-detail>
        </div>
        <!-- 地图 -->
        <div class="map" id="olMap" v-show="show.ztt !== 'aqxx'"></div>

        <!-- 地图弹出框 -->
        <div v-show="isShow && tckData" id="popupA">
            <div :class="isSp ? 'ol-popupSp' : 'ol-popup'" id="popup-contentA">
                <div>
                    <div style="position: absolute;transform: translate(0%,-50%);top: 50%;left: 10px;font-size: 1.4rem;">
                        {{ tckData ? (tckData.stnm ? tckData.stnm : '') : '' }}
                        <span style="color: #ea3d31">{{tckData.status===0 ? '异常' : ''}}</span>
                    </div>
                    <div style="position: absolute;transform: translate(0%,-50%);top: 50%;right: 10px;font-size: 1.4rem;">
                        {{ tckData ? (tckData.stcd ? tckData.stcd : '') : '' }}
                    </div>
                </div>
            </div>
            <div v-if="show.ztt === 'yqxx' && !isSp">
                <div style="position: absolute;min-width: 260px;left: 20px;top: -20px;background-color: #fff;font-family: 'PingFang SC';font-size: 1.4rem;border-bottom-left-radius: 5px;border-bottom-right-radius: 5px;">
                    <div style="width: 260px;">
                        <div style="background-color: #f7f7f7;border-radius: 4px;height: 40px;position:relative;margin: 10px 10px;">
                            <span style="position:absolute;transform: translate(0,-50%);top: 50%;left: 10px;color: black;">
                                累计雨量(mm)
                            </span>
                            <span style="position:absolute;transform: translate(0,-50%);top: 50%;right: 10px;color: rgb(44,131,234);">
                                {{tckData.drp ? tckData.drp : '-'}}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="show.ztt === 'sqxx' && !isSp">
                <div v-if="tckData.sttp === '0803' || tckData.sttp === '0804'" style="position: absolute;min-width: 260px;left: 20px;top: -20px;background-color: #fff;font-family: 'PingFang SC';font-size: 1.4rem;border-bottom-left-radius: 5px;border-bottom-right-radius: 5px;">
                    <div style="width: 260px;">
                        <div style="background-color: #f7f7f7;border-radius: 4px;height: 40px;position:relative;margin: 10px 10px;">
                            <span style="position:absolute;transform: translate(0,-50%);top: 50%;left: 10px;color: black;">
                                库水位(m)
                            </span>
                            <span style="position:absolute;transform: translate(0,-50%);top: 50%;right: 10px;color: rgb(44,131,234);">
                                {{tckData.rz ? tckData.rz : '-'}}
                            </span>
                        </div>
                        <div style="background-color: #f7f7f7;border-radius: 4px;height: 40px;position:relative;margin: 10px 10px;">
                            <span style="position:absolute;transform: translate(0,-50%);top: 50%;left: 10px;color: black;">
                                蓄水量(10⁴m³)
                            </span>
                            <span style="position:absolute;transform: translate(0,-50%);top: 50%;right: 10px;color: rgb(44,131,234);">
                                {{tckData.w ? tckData.w : '-'}}
                            </span>
                        </div>
                        <div style="background-color: #f7f7f7;border-radius: 4px;height: 40px;position:relative;margin: 10px 10px;">
                            <span style="position:absolute;transform: translate(0,-50%);top: 50%;left: 10px;color: black;">
                                入库流量(m³/s)
                            </span>
                            <span style="position:absolute;transform: translate(0,-50%);top: 50%;right: 10px;color: rgb(44,131,234);">
                                {{tckData.inboundFlow ? tckData.inboundFlow : '-'}}
                            </span>
                        </div>
                        <div style="background-color: #f7f7f7;border-radius: 4px;height: 40px;position:relative;margin: 10px 10px;">
                            <span style="position:absolute;transform: translate(0,-50%);top: 50%;left: 10px;color: black;">
                                出库流量(m³/s)
                            </span>
                            <span style="position:absolute;transform: translate(0,-50%);top: 50%;right: 10px;color: rgb(44,131,234);">
                                {{tckData.outboundFlow ? tckData.outboundFlow : '-'}}
                            </span>
                        </div>
                    </div>
                </div>
                <div v-else style="position: absolute;min-width: 260px;left: 20px;top: -20px;background-color: #fff;font-family: 'PingFang SC';font-size: 1.4rem;border-bottom-left-radius: 5px;border-bottom-right-radius: 5px;">
                    <div style="width: 260px;">
                        <div style="background-color: #f7f7f7;border-radius: 4px;height: 40px;position:relative;margin: 10px 10px;">
                            <span style="position:absolute;transform: translate(0,-50%);top: 50%;left: 10px;color: black;">
                                水位(m)
                            </span>
                            <span style="position:absolute;transform: translate(0,-50%);top: 50%;right: 10px;color: rgb(44,131,234);">
                                {{tckData.z ? tckData.z : '-'}}
                            </span>
                        </div>
                        <div style="background-color: #f7f7f7;border-radius: 4px;height: 40px;position:relative;margin: 10px 10px;">
                            <span style="position:absolute;transform: translate(0,-50%);top: 50%;left: 10px;color: black;">
                                流量(m³/s)
                            </span>
                            <span style="position:absolute;transform: translate(0,-50%);top: 50%;right: 10px;color: rgb(44,131,234);">
                                {{tckData.q ? tckData.q : '-'}}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 视图弹出框 -->
        <tz-item :txcs="txcs" ref="tzChildren"></tz-item>
        <sz-item :spcs="spcs" ref="szChildren"></sz-item>
    </div>
</template>
<script>
import "ol/ol.css";
import Map from "ol/Map";
import View from "ol/View";
import { Tile as TileLayer, Vector as VectorLayer, Image } from "ol/layer";
import VectorSource from "ol/source/Vector";
import { XYZ, WMTS, ImageWMS } from "ol/source";
import { defaults as defaultControls } from "ol/control";
import Point from "ol/geom/Point";
import Feature from "ol/Feature";
import Overlay from "ol/Overlay";
import { Icon,Style,Stroke,Fill,CircleStyle,Circle,Text } from "ol/style";

import ImageLayer from 'ol/layer/Image';
import { GeoJSON, WKT } from "ol/format";
import LinearRing from 'ol/geom/LinearRing.js';
import { fromExtent } from "ol/geom/Polygon";
import Screen_dzm from "./screen_dzm";
import Draw, {createBox} from "ol/interaction/Draw";
import {unByKey} from "ol/Observable";
import { getLength, getArea } from 'ol/sphere';

import ScaleLine from "ol/control/ScaleLine";
import * as control from "ol/control";

import rainOpen from "@/views/rainWaterS/open/rainOpen.vue";
import riverOpen from "@/views/rainWaterS/open/riverOpen.vue";
import rsvrOpen from "@/views/rainWaterS/open/rsvrOpen.vue";
import MonitorDetail from "../safetyS/monitorDetail";
import {isScroll} from "element-ui";
import * as THREE from "../../utils/basejs/three.min";
import {clearScene} from "../../utils/basejs/addThreeThings";
import {
    addGroup,
    addLine,
    addPoint,
    addTextGroup,
    addThings,
    clearSection,
    clearText,
    removeTextGroup
} from "../safetyS/js/things";
import PointDetail from "../safetyS/pointDetail";
import {TWEEN} from "../../utils/basejs/tween.module.min";
import {OrbitControls} from "@/utils/basejs/OrbitControls";
import router from "@/router";
import {nextTick} from "@vue/composition-api";
import mylOpen from "@/views/rainWaterS/open/mylOpen.vue";
import TzItem from '../st/tzItem.vue';
import SzItem from '../st/szItem.vue';

const aqxxColumnGrid = {
    '0601': {
        // show: true,
        left: '5%',
        right: '5%',
        bottom: '4%',
        top: '10%',
      containLabel: true
    },
    '0602':{
        // show: true,
        left: ' 5%',
        right: '5%',
        bottom: '4%',
        top: '10%',
      containLabel: true
    },
    '0603':{
        // show: true,
        left: ' 5%',
        right: '5%',
        bottom: '4%',
        top: '10%',
      containLabel: true
    },
    '0604':{
        // show: true,
        left: ' 5%',
        right: '5%',
        bottom: '4%',
        top: '10%',
      containLabel: true
    },
    '0605':{
        // show: true,
        left: ' 5%',
        right: '5%',
        bottom: '4%',
        top: '10%',
      containLabel: true
    },
    '0606':{
        // show: true,
        left: ' 5%',
        right: '5%',
        bottom: '4%',
        top: '10%',
      containLabel: true
    }

};
const aqxxColumnTypes =  {
  '0601': [
    {
      property: 'rwater',
      label: '实际水深(m)',
      width: 110,
      trend: false,
      lineColor: '#2c83ea',
      lineColorStop: 'rgba(0,218,252,0)',
      dw: '',
      bh: 'dataList2',
      yPosition: 'left',
      chartType: 'line',
      offset: 80,
      needChart: false
    },
    {
      property: 'tbbtel',
      label: '管底高程(m)',
      width: 110,
      trend: false,
      lineColor: '#2c83ea',
      lineColorStop: 'rgba(0,218,252,0)',
      dw: '',
      bh: 'dataList2',
      yPosition: 'left',
      chartType: 'line',
      offset: 80,
      needChart: false
    },

    {
      property: 'pztbwl',
      label: '测压管水位(m)',
      width: 110,
      trend: 'trend',
      lineColor: '#5470C6',
      lineColorStop: 'rgba(0,218,252,0)',
      bh: 'dataList1',
      yPosition: 'left',
      chartType: 'line',
      dw: '',
      needChart: true,
      needMaxMin: 'sw'
    },

    {
      property: 'wt',
      label: '温度(℃)',
      width: 110,
      trend: false,
      lineColor: '#FAC858',
      lineColorStop: 'rgba(0,218,252,0)',
      bh: 'wtList',
      yPosition: 'right',
      chartType: 'line',
      dw: '',
      needChart: true,
    }],
  '0602':
      [
        //   {'property': 'spprwl',label: '渗流压力水位(m)',width: '16.47%',needTreed:true,lineColor: '#00dcfe',lineColorStop: 'rgba(0,218,252,0)',dw:'',bh: 'dataList1',yPosition:'left',chartType: 'line'},
        // {'property': 'rwater',label: '实际水深(m)',width: '13.13%',needTreed:false,lineColor: '#2c83ea',lineColorStop: 'rgba(0,218,252,0)',dw:'',bh: 'dataList2',yPosition:'left',chartType: 'line',offset: 42},
        // {'property': 'wt',label: '温度（℃）',width: '12.9%',lineColor: '#FAC858',lineColorStop: 'rgba(0,218,252,0)',needTreed:false,bh: 'wtList',yPosition:'right',chartType: 'line',dw:''}],
        {
          property: 'spprwl',
          label: '渗流压力水位(m)',
          width: 110,
          trend: 'trend',
          lineColor: '#5470C6',
          lineColorStop: 'rgba(0,218,252,0)',
          dw: '',
          bh: 'dataList1',
          yPosition: 'left',
          chartType: 'line',
          needChart: true,
          needMaxMin: 'sw'
        },
        {
          property: 'wt',
          label: '温度(℃)',
          width: 114,
          lineColor: '#FAC858',
          lineColorStop: 'rgba(0,218,252,0)',
          trend: false,
          bh: 'wtList',
          yPosition: 'right',
          chartType: 'line',
          dw: '',
          needChart: true,
        }]
  , '0603':
      [{
        property: 'stn',
        label: '应变(10⁻⁶)',
        width: 155,
        trend: 'trend',
        lineColor: '#5470C6',
        lineColorStop: 'rgba(0,218,252,0)',
        bh: 'dataList1',
        yPosition: 'left',
        chartType: 'line',
        dw: '',
        needChart: true,
      },
        {
          property: 'wt',
          label: '温度(℃)',
          width: 114,
          trend: false,
          lineColor: '#FAC858',
          lineColorStop: 'rgba(0,218,252,0)',
          bh: 'wtList',
          yPosition: 'right',
          chartType: 'line',
          dw: '',
          needChart: true
        }]
  , '0604':
      [{
        property: 'xhrds',
        label: 'X向水平位移(mm)',
        width: 150,
        trend: 'xtrend',
        lineColor: '#5470C6',
        lineColorStop: 'rgba(0,218,252,0)',
        bh: 'dataList1',
        yPosition: 'left',
        chartType: 'line',
        dw: '',
        needChart: true
      },]
  , '0605':
      [{
        property: 'yhrds',
        label: 'Y向水平位移(mm)',
        width: 150,
        trend: 'ytrend',
        lineColor: '#5470C6',
        lineColorStop: 'rgba(0,218,252,0)',
        bh: 'dataList2',
        yPosition: 'left',
        chartType: 'line',
        dw: '',
        needChart: true
      }],
  '0606':
      [{
        property: 'vrds',
        label: '垂直位移(mm)',
        width: 150,
        trend: 'trend',
        lineColor: '#5470C6',
        lineColorStop: 'rgba(0,218,252,0)',
        bh: 'dataList1',
        yPosition: 'left',
        chartType: 'line',
        dw: '',
        needChart: true
      }]
};


let tdtLayer = null;
let yxdtLayer = null;
let hlLayer =null;
let dtImage = new VectorLayer({
    source: new VectorSource(),
    visible: true,
});
let dtImage2 = new VectorLayer({
    source: new VectorSource(),
    visible: true,
});
let stImage = new VectorLayer({
    source: new VectorSource(),
    visible: true,
});
let cz_img = new VectorLayer({
    source:new VectorSource(),
    visible: true,
    zIndex:110,
});
let renderer = null;
let scene = null;
let camera = null;
let controls = null;
export default {
    name: "screen",
    components: {
        mylOpen,
        PointDetail,
        Screen_dzm,
        rainOpen,
        riverOpen,
        rsvrOpen,
        MonitorDetail,
        TzItem,
        SzItem,
    },
    data() {
        return{
            tcList: ['测站'],
            mylData:{},
            mylCz:{
                mylOpenShow:false,
                cz:{},
                sjfw:[],
            },
            aqxxGrid: {},
            aqxxColumns: [],
            aqxxCurrentColumns : [],
            pointDetailShow: false,
            aqxxClickPoint: null,
            tmpPoint: null,
            timeDiv:null,
            requestID: null,
            raycaster: new THREE.Raycaster(),
            scrollFlag: true,
            tableTimer: null,
            tableTop: 0,
            tableList: [],
            tableListSize: 0,
            componentTimer: null,

            //需要根据情况设置的参数
            visibleSize: 1, //容器内可视最大完整行数
            lineHeight: 47, //每行的实际高度（包含margin-top/bottom,border等）
            componentTimerInterval: 60000, //刷新数据的时间间隔
            tableTimerInterval: 1000, //向上滚动 1px 所需要的时间，越小越快，推荐值 100
            aqxxItemList:[],
            yjList:[],
            skdtxx:[],
            czOptions:[],
            dataRange: [],
            tableData:[],
            tableData2: {
                stnm:"",
                rz:"",
                w:"",
                inboundFlow:"",
                outboundFlow:"",
            },
            sksqCheckd:true,
            tableRowCheck:true,
            tableData3:[],
            table3Key:"",
            tableData4:[],
            animate: false,
            show:{
                left:true,
                right:true,
                tool:false,
                table:{
                    extremelyHeavyRainstorm:false,
                    heavyRainstorm:false,
                    rainstorm:false,
                    heavyRain:false,
                    moderateRain:false,
                    lightRain:false,
                    noRain:false,
                },
                ztt:"yqxx",
            },

            selectd:{
                sdordzm:'sd',//散点or等值线or等值面
                aqxx:"0601",
                sjxz1:"jr",
            },
            czValue: "",
            skName:localStorage.getItem("skName") ? localStorage.getItem("skName") : "",
            skCd:localStorage.getItem("skCd") ? localStorage.getItem("skCd") : "",
            //雨水情参数
            rainCz:{
                openShow:false,
                cz:{},
                sjfw:[],
            },
            riverCz:{
                openShow:false,
                cz:{},
                sjfw:[],
            },
            rsvrCz:{
                openShow:false,
                cz:{},
                sjfw:[],
            },
            //地图参数
            geoImageWMSConfig:{
                params: {LAYERS: '', VERSION: '1.1.0', SRS: 'EPSG:4326'},
                serverType: 'geoserver',
                url: 'https://gis.hyicloud.com/zxsk/wms',
            },
            map:null,
            maplx:null,
            zoomNum:10,
            fdlevel:12,
            center:[83.166136, 42.148747],
            mapData:[],
            initLayer:null,
            xzData:{},
            isShow: false,
            tckData:{},
            zgData:[],
            czStatus:{
                abnormalNum:0,
                normaNum:0,
                totalNum:0,
            },
            //地图工具参数
            pointermoveEvent: null, // 地图pointermove事件
            sketchFeature: null, // 绘制的要素
            geometryListener: null, // 要素几何change事件
            measureResult: "0", // 测量结果
            draw: {},
            draw_source: new VectorSource(),
            draw_vector: {},
            measureType: "",
            tipDiv: null,
            vectorLayer: null,
            rowCheck:null,
            myrenderer:null,
            sjcommand:"1分钟",
            deadline:59,
            mins: '00',
            seconds: '00',
            timer: null,


            szData:[],
            tzData: [],
            isSp:false,
            txcs:{
                openShow:false,
                cz:{},
            },
            spcs:{
                openShow:false,
                cz:{},
            },
        }
    },
    methods:{
        aqxxTrendColor(trend) {
            if (trend === 1) {
                return '#fd1553';
            }
            if (trend === 0) {
                return '#15bffd';
            }
            return '';
        },
        tcChange(item){
            if (this.map) {
                this.map.removeLayer(stImage);
            }

            stImage = new VectorLayer({
                source: new VectorSource(),
                visible: true,
                zIndex: 120,
            });
            this.map.addLayer(stImage);

            if (item.includes("视频站")) {
                this.request.get("/rm-bvideo/queryVideoList").then((res) => {
                    if (res.ok) {
                        this.szData = res.data;

                        this.szData.forEach((n) => {
                            const ext = [parseFloat(n.lgtd), parseFloat(n.lttd)];
                            const wzimage = new Feature(new Point(ext));
                            wzimage.setStyle(new Style({image: new Icon({src: require("@/assets/video/sp.png"),scale: 1,zIndex: 110,})},));
                            wzimage.set("stcd", n.stcd);
                            wzimage.set("zl", 'spz');
                            wzimage.set("data", n);
                            stImage.getSource().addFeature(wzimage);
                        }); 
                    } else {
                        this.$message.error(res.error.message);
                    }
                });
            } else {
                this.szData = [];
            }
            if (item.includes("图像站")) {
                this.request.get("/rm-bimage/queryImageList").then((res) => {
                    if (res.ok) {
                        this.tzData = res.data;
                        this.tzData.forEach((n) => {
                            const ext1 = [parseFloat(n.lgtd), parseFloat(n.lttd)];
                            const wzimage1 = new Feature(new Point(ext1));
                            wzimage1.setStyle(new Style({image: new Icon({src: require("@/assets/video/tx.png"),scale: 1,zIndex: 110,})},));
                            wzimage1.set("stcd", n.stcd);
                            wzimage1.set("zl", 'txz');
                            wzimage1.set("data", n);
                            stImage.getSource().addFeature(wzimage1);
                        }); 
                    } else {
                        this.$message.error(res.error.message);
                    }
                });
            } else {
                this.tzData = [];
            }
        },
        mylShow(){
            this.mylCz.mylOpenShow = true;
            this.mylCz.cz = this.mylData;
            this.mylCz.sjfw = [...this.dataRange];
        },
        //倒计时
        countDown () {
            this.getTime(this.deadline)
        },
        getTime (duration) {
            // 执行时，将上一个setTimeout清除掉
            this.timer && clearTimeout(this.timer)
            if (duration < 0) {
                duration = this.deadline
            }

            const { dd, hh, mm, ss } = this.durationFormatter(duration)
            this.days = dd || 0
            this.hours = hh || 0
            this.mins = mm || 0
            this.seconds = ss || 0
            this.timer = setTimeout(() => {
                this.getTime(duration - 1)
                if(duration <= 0){
                    this.bsGetProductProcess();
                    this.initDataItem();
                }
            }, 1000)
        },
        durationFormatter (time) {
            if (!time) return { ss: 0 }
            let t = time

            const ss = t % 60
            t = (t - ss) / 60
            if (t < 1) return { ss }

            const mm = t % 60
            t = (t - mm) / 60
            if (t < 1) return { mm, ss }

            const hh = t % 24
            t = (t - hh) / 24
            if (t < 1) return { hh, mm, ss }

            const dd = t
            return { dd, hh, mm, ss }
        },
        handleCommand(command){
            this.sjcommand = command
            if(command === '5分钟'){
               this.componentTimerInterval =  300000
            }else if(command === '3分钟'){
                this.componentTimerInterval =  180000
            }else if(command === '1分钟'){
                this.componentTimerInterval =  60000
            }
            this.deadline = this.componentTimerInterval /1000 -1
            this.countDown()
        },
        toYjxx(){
            const currentRouteNames = this.$router.getRoutes().map(v => v.name)
            if (!currentRouteNames.includes('warninfo')) {
                this.$message.info("暂无预警信息权限！")
            }
            let btnList = JSON.parse(localStorage.getItem("menus"))

            let yjitem = {}
            for(let item of btnList){
                if( item.route === 'warn'){
                    yjitem =item
                }
            }
            this.$store.commit('selectMenu', yjitem.children[0]);
            this.$router.push({ name: yjitem.children[0].route });
        },
        animateFunction() {
            this.requestID = requestAnimationFrame(this.animateFunction);
            controls.update();
            TWEEN.update();
            // this.cameraRange();
            renderer.render(scene, camera);

        },
        cameraRange(){
            if(camera.position.x < 400){
                if(camera.position.y < 425) {
                    controls.target.set(400, 425, controls.target.z);
                    camera.position.set(400, 425, camera.position.z);
                }else if(camera.position.y > 690){
                    controls.target.set(400, 690, controls.target.z);
                    camera.position.set(400, 690, camera.position.z);
                }else{
                    controls.target.set(400,controls.target.y,controls.target.z);
                    camera.position.set(400,camera.position.y,camera.position.z);
                }
            }else
            if(camera.position.x > 1600){
                if(camera.position.y < 425) {
                    controls.target.set(1600, 425, controls.target.z);
                    camera.position.set(1600, 425, camera.position.z);
                }else if(camera.position.y > 690){
                    controls.target.set(1600, 690, controls.target.z);
                    camera.position.set(1600, 690, camera.position.z);
                }else{
                    controls.target.set(1600,controls.target.y,controls.target.z);
                    camera.position.set(1600,camera.position.y,camera.position.z);
                }
            }else{
                if(camera.position.y < 425) {
                    controls.target.set(controls.target.x, 425, controls.target.z);
                    camera.position.set(camera.position.x, 425, camera.position.z);
                }else if(camera.position.y > 690){
                    controls.target.set(controls.target.x,690, controls.target.z);
                    camera.position.set(camera.position.x, 690, camera.position.z);
                }else{
                    controls.saveState();
                }
            }
            if(camera.position.z < 500){
                addTextGroup();
            }else {
                removeTextGroup();
            }
        },
        handleAqxxRowClick(val) {
            this.tableRowCheck = true
            if(val){
                const mpcd = val.mpcd;
                const pointGroup = scene.getObjectByName('mps');
                if(pointGroup && pointGroup.children.length > 0){
                    pointGroup.traverse(n => {
                        if(n.bh && n.bh === mpcd){
                            if(this.aqxxClickPoint){
                                this.aqxxClickPoint.material.color.set('#3F00FF');
                            }
                            this.aqxxClickPoint = n;
                            n.material.color.set('#7FFFD4');
                            const x = n.position.x;
                            const y = n.position.y;
                            const target = {x:x,y:y,z:400};
                            this.animateCamera(target);
                            controls.target.set(x,y,0);
                        }
                    });
                }
            }
        },
        animateCamera(position){
            if(camera){
              const tween =new TWEEN.Tween(camera.position).to(position, 1000).easing(TWEEN.Easing.Sinusoidal.InOut)
                    .onUpdate((res) => {
                      camera.lookAt(res.x, res.y, 0);
                      controls.target.set(res.x, res.y, 0);
                    });
              tween.start();
            }
        },
        querySection(){
            this.request.get('/rm-bsection/querySectionCoordinate').then((res)=> {
                    if(res.ok){
                        const data = res.data;
                        addLine(data);
                    }else {
                        this.$message.error(res.error.message);
                    }
                }
            );
        },
        queryPoint(){
            const params = {mstp: this.selectd.aqxx};
            this.request.get('/rm-bmp/queryMpCoordinate/',{params: params}).then((res)=> {
                    if(res.ok){
                        const data = res.data;
                        addPoint(data,true);
                    }else {
                        this.$message.error(res.error.message);
                    }
                }
            );
        },
        aqxxPositionChange(worldPosition){
            const screenPosition = new THREE.Vector3();
            screenPosition.copy(worldPosition)
                .project(camera)
            const a = this.timeDiv.offsetWidth * 0.5;
            const b = this.timeDiv.offsetHeight * 0.5;
            // const c = this.timeDiv.offsetHeight * 0.75
            // const x = Math.round(screenPosition.x * a + )
            const x = (screenPosition.x * a) + a;
            const y = -(screenPosition.y * b) + b;
            return {x:  x + 40, y: y};
            const pointWidth = 260;
            // const width1 = tableDivWidth + 40;
            // const width2 = tableDivWidth - pointWidth - 40;
            const length = x  + pointWidth;
            const tableWidth = this.$refs.aqxxTable.offsetWidth;
            const dataShowRowWidth = this.timeDiv.offsetWidth - tableWidth;
            console.log(tableWidth)
            if(length > dataShowRowWidth){
                return {x:  x - 280, y: y};
            }else {
                return {x:  x + 20, y: y};
            }

        },
        onAqxxMouseMove(event) {
            const pointer = { x: null, y: null };
            pointer.x = (event.offsetX / this.timeDiv.offsetWidth) * 2 - 1;
            pointer.y = -(event.offsetY / this.timeDiv.offsetHeight) * 2 + 1;
            this.raycaster.setFromCamera(pointer, camera);
            const points = scene.getObjectByName('mps');
            const intersects = this.raycaster.intersectObjects(
                points.children
            );
            if (intersects.length > 0) {
                if(this.pointDetailShow){
                    return;
                }
                this.$refs.aqxxMap.style.cursor = 'pointer';
                const object = intersects[0].object;
                 if(this.tmpPoint) {
                        this.tmpPoint.material.color.set('#3F00FF');
                     }
               this.tmpPoint = object;
               object.material.color.set('#3CB371');
                const params = {mstp: this.selectd.aqxx,mstmGE: this.dataRange[0]+":00",
                    mstmLE: this.dataRange[1]+":00",mpcd: object.bh};
                this.request.post('/rm-rpzwl/queryMsData', params).then((res)=> {
                    if(res.ok){
                        const position = this.aqxxPositionChange(object.position);
                        if(!res.data){
                            const data = {mpcd: object.bh,
                                mstm: this.dataRange[1],
                                data1: null,
                                data2: null,
                                wt: null,
                                status: object.status,
                            }

                            this.$refs.aqxxPointDetail.positionChange(true,position,this.selectd.aqxx,data,true);
                            this.pointDetailShow = true;
                            // this.$refs.pointDetail.positionChange(false,position,this.activeButton,{});
                            return;
                        }
                        let da = res.data;
                        da.mstm = da.mstm.substring(0,16);
                        console.log(object.status)
                        const data = {...da,mpcd: object.bh,status: object.status};
                        this.$refs.aqxxPointDetail.positionChange(true,position,this.selectd.aqxx,data,true);
                        this.pointDetailShow = true;
                    }else {
                        this.pointDetailShow = false;
                        this.$refs.aqxxPointDetail.positionChange(false,position,this.selectd.aqxx,{});
                    }
                });
            }else{
              if(this.tmpPoint){
                if(this.aqxxClickPoint && this.aqxxClickPoint.bh === this.tmpPoint.bh){
                  this.tmpPoint.material.color.set('#7FFFD4');
                }else {
                  this.tmpPoint.material.color.set('#3F00FF');
                }
                this.tmpPoint = undefined;
              }
                this.pointDetailShow = false;
                this.$refs.aqxxPointDetail.positionChange(false,{},this.activeButton,{});
                this.$refs.aqxxMap.style.cursor = 'auto';
            }
        },
        threeInit() {
            if(!this.requestID) {
                this.timeDiv = this.$refs.aqxxMap;
                camera = new THREE.PerspectiveCamera(
                    80,
                    this.timeDiv.offsetWidth / this.timeDiv.offsetHeight,
                    1,
                    12000
                );

                camera.position.set(980, 500, 735);
                renderer = new THREE.WebGLRenderer({antialias: true});
                renderer.setPixelRatio(window.devicePixelRatio);
                renderer.setSize(
                    this.timeDiv.offsetWidth,
                    this.timeDiv.offsetHeight
                );
                renderer.antialias = true;
                renderer.alpha = true;
                this.timeDiv.append(renderer.domElement);

                scene = new THREE.Scene();
                scene.background = new THREE.Color('#DCDBD6');
                controls = new OrbitControls(
                    camera,
                    renderer.domElement
                );
                // this.renderer = renderer
                controls.enableRotate = true;
                controls.autoRotate = false;
                controls.minDistance = 200;
                controls.maxDistance = 1000;
                // controls.target0.set(800, 400, 0);
                controls.target.set(980, 500, 0);

                controls.mouseButtons = {
                    LEFT: THREE.MOUSE.PAN,
                    MIDDLE: THREE.MOUSE.DOLLY,
                    RIGHT: THREE.MOUSE.ROTATE,
                };
                addThings();
                addGroup(scene);
                this.animateFunction();
                this.timeDiv.addEventListener("click", this.onAqxxMouseClick, true);
                this.timeDiv.addEventListener("mousemove", this.onAqxxMouseMove, true);
            }
        },
        onAqxxRowClick(row){
          this.onAqxxDetailShow(row.mpcd);
        },
        onAqxxDetailShow(mpcd){
          if(this.pointDetailShow){
            this.pointDetailShow = false;
            this.$refs.aqxxPointDetail.positionChange(false,{},this.activeButton,{});
          }
            const dateTime = [this.dataRange[0]+':00',this.dataRange[1]+':00'];
            this.$refs.aqxxDetail.initColumns(this.aqxxColumns, this.selectd.aqxx, mpcd, dateTime,this.aqxxGrid);
        },
        onAqxxMouseClick(event) {
            const pointer = { x: null, y: null };
            pointer.x = (event.offsetX / this.timeDiv.offsetWidth) * 2 - 1;
            pointer.y = -(event.offsetY / this.timeDiv.offsetHeight) * 2 + 1;
            this.raycaster.setFromCamera(pointer, camera);
            const points = scene.getObjectByName('mps');
            const intersects = this.raycaster.intersectObjects(
                points.children
            );
            if(intersects.length > 0){
                const object = intersects[0].object;
                this.onAqxxDetailShow(object.bh);
            }
        },
        handleYr(e){
            // console.log('e0',e)
            e.currentTarget.className = 'tr1 yjactive';
            this.scrollFlag = false
        },
        handleYjcdYc(e){
            e.currentTarget.className = 'tr1 tr';
            this.scrollFlag = true
        },
        getYjData(){
            this.request.post('/rm-tyjxx/queryYjxxList',{ yjzt: 0}).then((res) => {
                if(res.ok){
                    this.yjList = res.data.records
                }
            })
        },
        clickJcz(val,zl){
            if (zl) {
                if (zl == 'txz') {
                    this.txcs.openShow = true;
                    this.txcs.cz = val;
                } else if (zl == 'spz') {
                    this.spcs.openShow = true;
                    this.spcs.cz = val;
                }
                return;
            }

            if (this.show.ztt == 'yqxx') {
                this.rainCz.openShow = true;
                this.rainCz.cz = val;
                this.rainCz.sjfw = [...this.dataRange];
            } else if (this.show.ztt == 'sqxx') {
                if (val.sttp === '0803' || val.sttp === '0804') {
                    this.rsvrCz.openShow = true;
                    this.rsvrCz.cz = val;
                    this.rsvrCz.sjfw = [...this.dataRange];
                } else {
                    this.riverCz.openShow = true;
                    this.riverCz.cz = val;
                    this.riverCz.sjfw = [...this.dataRange];
                }

            }
        },
        clickData(row,index){
            let zoomz = this.fdlevel;
            if (row.lgtd&&row.lttd) {
                this.map.getView().animate({
                    center: [row.lgtd,row.lttd],
                    zoom: zoomz,
                });
            } else {
                return;
            }
            this.rowCheck = row.stcd
            this.tableRowCheck = true
            if(row.sttp === '0803' || row.sttp === '0804'){
                this.sksqCheckd = true
            }else{
                this.sksqCheckd = false
            }
        },
        getData(){
            this.czValue = '';
            this.czOptions = [];

            this.sksqCheckd = false
            this.tableRowCheck = false
            let jcxm = null;
            let params = {
                tmGe:this.dataRange[0],
                tmLe:this.dataRange[1],
            }
            let params2 = {
                tmGT:this.dataRange[0]+":00",
                //tmGT:"2024-04-01 00:00:00",
                tmLE:this.dataRange[1]+":00",
            }
            if(this.show.ztt === 'yqxx'){
                this.request.get("/rm-hp/rain",{params: params}).then((res) => {
                    if(res.data){
                        this.tableData = [
                            {
                                name:"特大暴雨(250以上)",
                                length:0,
                                label:1,
                                id:1,
                                children:[],
                            },
                            {
                                name:"大暴雨(100-250)",
                                length:0,
                                label:1,
                                id:2,
                                children:[],
                            },
                            {
                                name:"暴雨(50-100)",
                                length:0,
                                label:1,
                                id:3,
                                children:[],
                            },
                            {
                                name:"大雨(25-50)",
                                length:0,
                                label:1,
                                id:4,
                                children:[],
                            },
                            {
                                name:"中雨(10-25)",
                                length:0,
                                label:1,
                                id:5,
                                children:[],
                            },
                            {
                                name:"小雨(0-10)",
                                length:0,
                                label:1,
                                id:6,
                                children:[],
                            },
                            {
                                name:"无雨(0)",
                                length:0,
                                label:1,
                                id:7,
                                children:[],
                            }
                        ]
                        if(res.data.noRain.length > 0) {
                            this.$set(this.tableData[6],'children', [])
                            for (let i of res.data.noRain){
                                this.tableData[6].children.push(i)
                            }
                            this.tableData[6].length = res.data.noRain.length
                            this.show.table.noRain = res.data.noRain.length > 0 ? true :false
                        }
                        if(res.data.lightRain.length > 0) {
                            this.$set(this.tableData[5],'children', [])
                            for (let i of res.data.lightRain){
                                this.tableData[5].children.push(i)
                            }
                            this.tableData[5].length = res.data.lightRain.length
                            this.show.table.lightRain = res.data.lightRain.length > 0 ? true :false
                        }
                        if(res.data.moderateRain.length > 0) {
                            this.$set(this.tableData[4],'children', [])
                            for (let i of res.data.moderateRain){
                                this.tableData[4].children.push(i)
                            }
                            this.tableData[4].length = res.data.moderateRain.length
                            this.show.table.moderateRain = res.data.moderateRain.length > 0 ? true :false
                        }
                        if(res.data.heavyRain.length > 0) {
                            this.$set(this.tableData[3],'children', [])
                            for (let i of res.data.heavyRain){
                                this.tableData[3].children.push(i)
                            }
                            this.tableData[3].length = res.data.heavyRain.length
                            this.show.table.heavyRain = res.data.heavyRain.length > 0 ? true :false

                        }
                        if(res.data.rainstorm.length > 0) {
                            this.$set(this.tableData[2],'children', [])
                            for (let i of res.data.rainstorm){
                                this.tableData[2].children.push(i)
                            }
                            this.tableData[2].length = res.data.rainstorm.length
                            this.show.table.rainstorm = res.data.rainstorm.length > 0 ? true :false
                        }
                        if(res.data.heavyRainstorm.length > 0) {
                            this.$set(this.tableData[1],'children', [])
                            for (let i of res.data.heavyRainstorm){
                                this.tableData[1].children.push(i)
                            }
                            this.tableData[1].length = res.data.heavyRainstorm.length
                            this.show.table.heavyRainstorm = res.data.heavyRainstorm.length > 0 ? true :false
                        }
                        if(res.data.extremelyHeavyRainstorm.length > 0) {
                            this.$set(this.tableData[0],'children', [])
                            for (let i of res.data.extremelyHeavyRainstorm){
                                this.tableData[0].children.push(i)
                            }
                            this.tableData[0].length = res.data.extremelyHeavyRainstorm.length
                            this.show.table.extremelyHeavyRainstorm = res.data.extremelyHeavyRainstorm.length > 0 ? true :false
                        }
                        this.tableData =  this.tableData.filter(item => item.length > 0)
                    }

                })

                this.request.get("/rm-mrain/v1/getMaxRainInfo",{params:params2}).then((res) => {
                    if(res.ok){
                        this.zgData = res.data;
                    }else{
                        this.$message.error(res.error.message)
                    }
                });
                this.request.get("/rm-mrain/v1/resRain",{params:params2}).then((res) => {
                    if(res.ok){
                        this.mylData = res.data;
                    }else{
                        this.$message.error(res.error.message)
                    }
                });
                jcxm = '0610'
            }else if(this.show.ztt === 'sqxx'){
                this.request.get("/rm-mrsvr/v1/list",{params:params2}).then((res) => {
                    if(res.ok){
                        this.tableData2 = res.data[0]
                    }else{
                        this.$message.error(res.error.message)
                    }
                });

                this.request.get("/rm-mriver/v1/list",{params:params2}).then((res) => {
                    if(res.ok){
                        this.tableData3 = res.data
                        this.table3Key = Math.random()

                    }else{
                        this.$message.error(res.error.message)
                    }
                });
                jcxm = '0607,0612,0608,0609'
            }else if(this.show.ztt === 'aqxx'){
                this.request.get('/rm-bmp/queryMstpListByRescd').then((res)=> {
                    if(res.ok){
                        const data = res.data;
                        this.aqxxItemList = data.mstps;
                        this.aqxxColumns = aqxxColumnTypes[this.selectd.aqxx];
                        this.aqxxGrid = aqxxColumnGrid[this.selectd.aqxx];
                    }else {
                        this.$message.error(res.error.message);
                    }
                })
                let params3 = {
                    mstmGE: this.dataRange[0]+":00",
                    mstmLE: this.dataRange[1]+":00",
                    /* mstmGE: "2021-01-01 00:00:00",
                     mstmLE: "2021-04-01 00:00:00",*/
                    mstp: this.selectd.aqxx
                }

                this.request.post('/rm-rpzwl/queryAqjcList', params3).then((res)=> {
                        if(res.ok){
                            this.tableData4 = res.data;
                            this.$nextTick(() => {
                                this.$refs.tableRef.doLayout();
                            });
                            this.threeInit();
                        }else {
                            this.$message.error(res.error.message);
                        }
                    }
                );

                jcxm = this.selectd.aqxx
                clearText();
                if(this.selectd.aqxx === '0601'){
                    this.querySection();
                }else {
                    clearSection();
                }
                this.queryPoint();
            }

            this.request.get("/rm-hp/status/"+jcxm).then((res) => {
                if(res.ok){
                    this.czStatus.abnormalNum = res.data.abnormalNum
                    this.czStatus.normaNum = res.data.normaNum
                    this.czStatus.totalNum = res.data.totalNum

                }else{
                    this.$message.error(res.error.message)
                }
            })
            this.hqdtdw();



        },
        kzkz(){
            this.$nextTick(()=>{
                this.czMap();
                this.sxwz();
            })
        },
        //获取地图点位
        hqdtdw(){
            let htGE = this.dataRange[0] + ':00';
            let htLE = this.dataRange[1] + ':00';
            let b = {
                tmGT:htGE,
                tmLE:htLE,
            }
            if (this.show.ztt == 'yqxx') {
                this.request.get('/rm-mrain/v1/list',{ params: b }).then((res) => {
                    if(res.ok){
                        this.mapData = res.data;

                        for(let item of this.skdtxx){
                            item.lgtd =  item.jd
                            item.lttd =  item.wd
                            item.stnm = '温度计'
                            item.lxbh ==='WT' ? this.mapData.push(item) : ''
                        }
                        this.mapTb();
                        this.showCzData();
                    }else{
                        this.$message.error(res.error.message)
                    }
                });
            } else if (this.show.ztt == 'sqxx') {
                this.request.get('/rm-mriver/v1/list',{ params: b }).then((res) => {
                    if(res.ok){
                        this.mapData= res.data;
                        this.request.get('/rm-mrsvr/v1/list',{ params: b }).then((res2) => {
                            if(res2.ok){
                                this.mapData = this.mapData.concat(res2.data)
                                this.mapTb();
                                this.showCzData();
                            }else{
                                this.$message.error(res.error.message)
                            }
                        });

                    }else{
                        this.$message.error(res.error.message)
                    }
                });
            } else if (this.show.ztt == 'aqxx') {
                // this.request.get('/rm-mrain/v1/list',{ params: b }).then((res) => {
                //     if(res.ok){
                //         this.mapData = res.data;
                //     }else{
                //         this.$message.error(res.error.message)
                //     }
                // });
                return;
            }
           // this.sxwz();

        },
        queryCz(query){
            if (query !== '') {
                let htGE = this.dataRange[0] + ':00';
                let htLE = this.dataRange[1] + ':00';
                let b = {
                    tmGT:htGE,
                    tmLE:htLE,
                    czOrbh:query,
                }
                if (this.show.ztt == 'yqxx') {
                    this.request.get('/rm-mrain/v1/list',{ params: b }).then((res) => {
                        if(res.ok){
                            if(res.data.length !== 0){
                                for(let data of res.data){
                                    data.lable = data.stcd + '/' + data.stnm;
                                }
                                this.czOptions = res.data;
                            }else{
                                this.$nextTick(()=>{
                                    this.$refs.mySelect.selectedLabel = val
                                })
                            }
                        }else{
                            this.$message.error(res.error.message)
                        }
                    });
                } else if (this.show.ztt == 'sqxx') {
                    this.request.get('/rm-mriver/v1/list',{ params: b }).then((res) => {
                        if(res.ok){
                            if(res.data.length !== 0){
                                for(let data of res.data){
                                    data.lable = data.stcd + '/' + data.stnm;
                                }
                                this.czOptions = res.data;
                            }else{
                                this.$nextTick(()=>{
                                    this.$refs.mySelect.selectedLabel = val
                                })
                            }
                        }else{
                            this.$message.error(res.error.message)
                        }
                    });
                } else if (this.show.ztt == 'aqxx') {
                    const params = {
                        mstp: this.selectd.aqxx,
                        mpnm: query,
                    };
                    this.request.get('/rm-bmp/queryMpCoordinate/',{ params: params }).then((res) => {
                        if(res.ok){
                            if(res.data.length !== 0){
                                for(let data of res.data){
                                    data.lable = data.mpcd + '/' + data.mpnm;
                                }
                                this.czOptions = res.data;
                            }else{
                                this.$nextTick(()=>{
                                    this.$refs.mySelect.selectedLabel = val
                                })
                            }
                        }else{
                            this.$message.error(res.error.message)
                        }
                    });
                }
            } else {
                this.czOptions = [];
            }
        },
        qcqueryCz(){
            this.czOptions = [];
            this.sxwz()
        },
        czChange(val){
            this.$nextTick(()=>{
                this.$refs.mySelect.selectedLabel = val;
                this.czValue = val;
            })
            if (this.show.ztt == 'aqxx') {
                let selectCz = this.czOptions.filter(item =>{
                    if (item.mpnm === val) {
                        return item
                    }
                })
                this.handleAqxxRowClick(selectCz[0]);
            } else {
                let selectCz = this.czOptions.filter(item =>{
                    if (item.stnm === val) {
                        return item
                    }
                })
                let zoomz = this.fdlevel;
                if(selectCz.length > 0){
                    if (selectCz[0].lgtd&&selectCz[0].lttd) {
                        this.map.getView().animate({
                            center: [selectCz[0].lgtd,selectCz[0].lttd],
                            zoom: zoomz,
                        });
                    } else {
                        return;
                    }
                }
            }
        },
        changeSdordzm(val){
            this.selectd.sdordzm =val
            if('sd' !== val){
                const skdm = localStorage.getItem("skCd") ? localStorage.getItem("skCd") : null;
                if(skdm === '65292330001'){
                    this.$refs.screen_dzm.changeImageType(val,true);
                }else {
                    this.$refs.screen_dzm.changeImageType(val,false);
                }
            }
        },
        changeAqxxSelect(val){
            this.selectd.aqxx =val
            this.getData();

        },
        changeSjxz1(val){
            this.selectd.sjxz1 =val
            this.dataRange = []
            let nowdate = this.getdate(0,0,0)

            var today = new Date();

            if(val === 'yxs'){
                let yxs =  this.getdate(0,-1,0)
                this.dataRange.push(yxs)
                this.dataRange.push(nowdate)
            }else if(val === 'sxs'){
                let sxs =  this.getdate(0,-3,0)
                this.dataRange.push(sxs)
                this.dataRange.push(nowdate)
            }else if(val === 'lxs'){
                let lxs =  this.getdate(0,-6,0)
                this.dataRange.push(lxs)
                this.dataRange.push(nowdate)
            }else if(val === 'sexs'){
                let sexs =  this.getdate(0,-12,0)
                this.dataRange.push(sexs)
                this.dataRange.push(nowdate)
            }else if(val === 'esxs'){
                let esxs =  this.getdate(0,-24,0)
                this.dataRange.push(esxs)
                this.dataRange.push(nowdate)
            }else if(val === 'jr'){
                var jr = ''
                if(today.getHours() < 8){
                    jr = this.getdate(0,0,-1)
                }else{
                    jr = this.getdate(0,0,0)
                }
                jr  =  jr.substring(0,jr.length - 5) +"08:00"
                this.dataRange.push(jr)
                this.dataRange.push(nowdate)
            }else if(val === 'zr'){
                var zr = ''
                if(today.getHours() < 8){
                    jr = this.getdate(0,0,-1)
                    zr = this.getdate(0,0,-2)
                }else{
                    jr = this.getdate(0,0,0)
                    zr = this.getdate(0,0,-1)
                }
                zr  =  zr.substring(0,zr.length - 5) +"08:00"
                jr  =  jr.substring(0,jr.length - 5) +"08:00"
                this.dataRange.push(zr)
                this.dataRange.push(jr)
            }
            this.getData();
        },
        initDataItem(val){
            this.changeSjxz1(val ? val : this.selectd.sjxz1)
            // this.getYjData();
        },
        getdate(minute,hour,day) {
            var today = new Date();
            var targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;
            if(hour !== 0){
                targetday_milliseconds = targetday_milliseconds + 1000 * 60 * 60 * hour
            }
            if(minute !== 0){
                targetday_milliseconds = targetday_milliseconds + 1000 * 60 * minute
            }
            today.setTime(targetday_milliseconds); //注意，这行是关键代码

            var tYear = today.getFullYear();
            var tMonth = today.getMonth();
            var tDate = today.getDate();
            tMonth = this.doHandleMonth(tMonth + 1);
            tDate = this.doHandleMonth(tDate);
            var thours = today.getHours();
            thours = this.doHandleMonth(thours);
            var tMinute =  today.getMinutes();
            tMinute = this.doHandleMonth(tMinute);
            return tYear + "-" + tMonth + "-" + tDate +" "+thours+":"+tMinute;
        },
        doHandleMonth(month) {
            var m = month;
            if (month.toString().length === 1) {
                m = "0" + month;
            }
            return m;
        },
        //合并行或列
        arraySpanMethod({ row, column, rowIndex, columnIndex }) {

            if(columnIndex === 0){
                return {
                    rowspan: 1,
                    colspan: 3
                };
            }else if(columnIndex === 1 || columnIndex === 2){
                return {
                    rowspan: 0,
                    colspan: 0
                };
            }else{
                return {
                    rowspan: 1,
                    colspan: 1
                };
            }
        },
        tableRowClassName({row, rowIndex}) {
            if (rowIndex % 2 === 1) {
                return 'el-table-double';
            }
            return '';
        },

        qhMap(){
            let skCd = localStorage.getItem("skCd") ? localStorage.getItem("skCd") : null;
            if (skCd) {
                if(skCd == '65292330001'){
                    this.showArea();
                    tdtLayer.setVisible(true);
                    hlLayer.setVisible(true);
                    yxdtLayer.setVisible(false);
                    this.$refs.screen_dzm.onInit();
                } else {
                    this.$refs.screen_dzm.onClear();
                    yxdtLayer.setVisible(true);
                    tdtLayer.setVisible(false);
                    hlLayer.setVisible(false);
                    if (this.map) {
                        this.map.removeLayer(this.initLayer);
                    }
                }


                for (let i = 0; i < this.skdtxx.length; i++) {
                    if (skCd == parseFloat(this.skdtxx[i].bh)) {
                        this.maplx = this.skdtxx[i].map;
                        this.zoomNum = parseFloat(this.skdtxx[i].level);
                        this.fdlevel = parseFloat(this.skdtxx[i].fdlevel);
                        this.center[0] = parseFloat(this.skdtxx[i].jd);
                        this.center[1] = parseFloat(this.skdtxx[i].wd);
                        break;
                    } else {
                        this.zoomNum = 4;
                        this.center = [103.95, 34.10];
                    }
                }
                let view = this.map.getView();
                view.setZoom(this.zoomNum); // 重新设置地图放大倍数
                view.setCenter(this.center,'EPSG:4326'); // 重新设置中心点的坐标

            } else {
                return;
            }
        },
        //初始化地图
        initMap() {
            let skCd = localStorage.getItem("skCd") ? localStorage.getItem("skCd") : null;
            tdtLayer = new TileLayer({
                source: new XYZ({  //矢量底图
                    url: 'https://t{0-7}.tianditu.gov.cn/DataServer?x={x}&y={y}&l={z}&T=vec_w&tk=8156b60f5ff7ee9619e3c84a1a7fe491'
                }),
                visible: true,
            });
            yxdtLayer = new TileLayer({
                source: new XYZ({  //影像底图
                    url: 'https://t{0-7}.tianditu.gov.cn/DataServer?x={x}&y={y}&l={z}&T=img_w&tk=8156b60f5ff7ee9619e3c84a1a7fe491'
                }),
                visible: false,
            });


            if (skCd) {
                if(skCd == '65292330001' || this.maplx == "JD"){
                    tdtLayer.setVisible(true);
                    yxdtLayer.setVisible(false);
                } else if(this.maplx == "YX") {
                    tdtLayer.setVisible(false);
                    yxdtLayer.setVisible(true);
                }
            }

            // 加载地图
            const map = new Map({
                target: "olMap",
                layers:[tdtLayer,yxdtLayer],
                view: new View({
                    //中心点经纬度
                    center: this.center,
                    //图层缩放大小
                    zoom: this.zoomNum,
                    projection: "EPSG:4326",
                }),
                controls: defaultControls({
                    zoom: true,
                    attribution: false,
                    rotate: false,
                }),
            });
            this.map = map;

            //创建蒙层，凸显区域
            this.showArea();



            // 添加注记
            // let cvaUrl = "http://t{0-7}.tianditu.com/DataServer?x={x}&y={y}&l={z}&T=cva_c&tk=8156b60f5ff7ee9619e3c84a1a7fe491";
            // const sourceCVA = new XYZ({
            //     url: cvaUrl,
            //     projection: "EPSG:4326",
            // });
            // const tdtcvaLayer = new TileLayer({
            //     title: '世界名称底图',
            //     source: sourceCVA,
            // });
            // this.map.addLayer(tdtcvaLayer);
        },
        showArea(d,val){
            let skCd = localStorage.getItem("skCd") ? localStorage.getItem("skCd") : null;
            if (skCd) {
                if (skCd == '65292330001') {
                    if (d) {
                        if (this.map) {
                            this.map.removeLayer(this.initLayer);
                        }
                    }
                    let mcYs = 'rgba( 0, 0, 0, 0.1)';

                    this.initLayer = new VectorLayer({
                        zIndex: 3,
                        source: new VectorSource(),
                        style: new Style({
                            fill: new Fill({
                                color:mcYs,
                            }),
                            stroke: new Stroke({
                                color:"#f4b49f",
                                // color:'rgba(255, 255, 255, 1)',
                                width:2,
                            }),
                        })
                    });
                    this.map.addLayer(this.initLayer);
                    let url = "https://gis.hyicloud.com/zxsk/ows?service=WFS&version=1.1.0&request=GetFeature&outputFormat=json&typeName=zxsk:tcsk";
                    // let url = "https://gis.hyicloud.com/area_border/ows?service=WFS&version=1.0.0&request=GetFeature&outputFormat=json&typeName=area_border:districtBorder&cql_filter=id=150627";
                    this.$axios.get(url).then((res) => {
                        this.addConver(this.initLayer, res.data.features[0]);
                    });
                }
            } else {
                return;
            }
        },
        //添加遮罩
        addConver(converLayer, data) {
            const fts = new GeoJSON().readFeatures(data);
            const ft = fts[0];
            const converGeom = this.erase(ft.getGeometry());
            const convertFt = new Feature({
                geometry: converGeom,
            });
            converLayer.getSource().addFeature(convertFt);
        },
        //擦除操作，生产遮罩范围
        erase(geom) {
            const extent = [-180, -90, 180, 90];
            const polygonRing = fromExtent(extent);
            const coords = geom.getCoordinates();
            coords.forEach(coord => {
                const linearRing = new LinearRing(coord[0]);
                polygonRing.appendLinearRing(linearRing);
            });
            return polygonRing;
        },
        // 河流图层
        sethlLayer(){
            let skCd = localStorage.getItem("skCd") ? localStorage.getItem("skCd") : null;
            if (skCd) {
                if (skCd == '65292330001') {
                    let iwconfigs = {...this.geoImageWMSConfig};
                    iwconfigs.params.LAYERS = "zxsk:rivers";
                    let source = new ImageWMS({...iwconfigs});
                    hlLayer = new ImageLayer({
                        title: '河流图层',
                        source: source,
                        zIndex:120,
                        visible: true,
                    });
                    this.map.addLayer(hlLayer);
                } else {
                    let iwconfigs = {...this.geoImageWMSConfig};
                    iwconfigs.params.LAYERS = "zxsk:rivers";
                    let source = new ImageWMS({...iwconfigs});
                    hlLayer = new ImageLayer({
                        title: '河流图层',
                        source: source,
                        zIndex:120,
                        visible: false,
                    });
                    this.map.addLayer(hlLayer);
                }
            } else {
                return;
            }
        },
        //地图添加测站状态图标
        mapStatusTb(){
            if (this.map) {
                this.map.removeLayer(dtImage2);
            }
            dtImage2 = new VectorLayer({
                source: new VectorSource(),
                visible: true,
                zIndex: 120,
            });
            this.map.addLayer(dtImage2);
            for(let data of this.mapData){
                const ext = [parseFloat(data.lgtd), parseFloat(data.lttd)];
                const wzimage = new Feature(new Point(ext));
                wzimage.setStyle(
                    new Style(
                        {
                            text:new Text(
                                {
                                    text: '\r\r'+data.stnm+'\r',
                                    textAlign: "center",
                                    offsetY: 20,
                                    backgroundFill: new Stroke({
                                        color: 'rgba(44,131,243,0.8)',
                                    }),
                                    // 文本填充样式
                                    fill: new Fill({
                                        color: 'rgba(255,255,255,1)',
                                    }),
                                    scale: 1.5
                                }
                            )
                        }
                    )
                )
                wzimage.set("data", data);
                cz_img.getSource().addFeature(wzimage);
            }

        },
        //地图添加图标
        mapTb(){
            if (this.map) {
                this.map.removeLayer(dtImage);
            }

            dtImage = new VectorLayer({
                source: new VectorSource(),
                visible: true,
                zIndex: 120,
            });
            this.map.addLayer(dtImage);
            //接入温度计特殊点


            if (this.show.ztt == 'yqxx') {
                this.mapData.forEach((n) => {
                    const ext = [parseFloat(n.lgtd), parseFloat(n.lttd)];
                    const wzimage = new Feature(new Point(ext));
                    const wzimage2 = new Feature(new Point(ext));
                    if (0<n.drp && n.drp<=10) {
                        wzimage.setStyle(new Style({image: new Icon({src: require("@/assets/images/ysqjc/ylA.png"),scale: 1,zIndex: 110,})},));
                    } else if (10<n.drp && n.drp<=25) {
                        wzimage.setStyle(new Style({image: new Icon({src: require("@/assets/images/ysqjc/ylB.png"),scale: 1,zIndex: 110,})}));
                    } else if (25<n.drp && n.drp<=50) {
                        wzimage.setStyle(new Style({image: new Icon({src: require("@/assets/images/ysqjc/ylC.png"),scale: 1,zIndex: 110,})}));
                    } else if (50<n.drp && n.drp<=100) {
                        wzimage.setStyle(new Style({image: new Icon({src: require("@/assets/images/ysqjc/ylD.png"),scale: 1,zIndex: 110,})}));
                    } else if (100<n.drp && n.drp<=250) {
                        wzimage.setStyle(new Style({image: new Icon({src: require("@/assets/images/ysqjc/ylE.png"),scale: 1,zIndex: 110,})}));
                    } else if (250<n.drp) {
                        wzimage.setStyle(new Style({image: new Icon({src: require("@/assets/images/ysqjc/ylF.png"),scale: 1,zIndex: 110,})}));
                    } else {
                        wzimage.setStyle(new Style({image: new Icon({src: require("@/assets/images/ysqjc/ylG.png"),scale: 1,zIndex: 110,})}));
                    }
                    if(n.lxbh === 'WT'){
                        wzimage.setStyle(new Style({image: new Icon({src: require("@/assets/yzt/wdj.png"),scale: 1,zIndex: 110,}),
                            text:new Text(
                                {
                                    text: n.value,
                                    textAlign: "center",
                                    offsetX: 30,
                                    //offsetY: 15,
                                    backgroundFill: new Stroke({
                                        color: 'rgba(44,131,243,0.8)',
                                    }),
                                    // 文本填充样式
                                    fill: new Fill({
                                        color: 'rgba(255,255,255,1)',
                                    }),
                                    scale: 1.5
                                }
                            )
                        }));
                    }

                    wzimage.set("stcd", n.stcd);
                    wzimage.set("data", n);
                    dtImage.getSource().addFeature(wzimage);
                    if(n.status === 0){
                        wzimage2.setStyle(new Style(
                            {image: new Icon({src: require("@/assets/yzt/abnormalNum.png"),zIndex: 110,anchor: [1.2, 1]})},
                        ));
                        dtImage.getSource().addFeature(wzimage2);
                    }
                });
            } else if (this.show.ztt == 'sqxx') {
                this.mapData.forEach((n) => {
                    const ext = [parseFloat(n.lgtd), parseFloat(n.lttd)];
                    const wzimage = new Feature(new Point(ext));
                    const wzimage2 = new Feature(new Point(ext));

                    if(n.sttp === '0803' || n.sttp === '0804'){
                        if (n.rz) {
                            if (n.sjhsw && n.rz>n.sjhsw) {
                                wzimage.setStyle(new Style({image: new Icon({src: require("@/assets/images/ysqjc/skC.png"),scale: 1,zIndex: 110,})}));
                            } else if(n.fhxzsw && n.rz>n.fhxzsw) {
                                wzimage.setStyle(new Style({image: new Icon({src: require("@/assets/images/ysqjc/skB.png"),scale: 1,zIndex: 110,})}));
                            } else {
                                wzimage.setStyle(new Style({image: new Icon({src: require("@/assets/images/ysqjc/skA.png"),scale: 1,zIndex: 110,})}));
                            }
                        } else {
                            wzimage.setStyle(new Style({image: new Icon({src: require("@/assets/images/ysqjc/skA.png"),scale: 1,zIndex: 110,})}));
                        }
                    }else if(n.sttp === '0802' || n.sttp === '0805'){
                        if (n.z) {
                            if (n.ensureZ && n.z>n.ensureZ) {
                                wzimage.setStyle(new Style({image: new Icon({src: require("@/assets/images/ysqjc/hdC.png"),scale: 1,zIndex: 110,})}));
                            } else if(n.alertZ && n.z>n.alertZ) {
                                wzimage.setStyle(new Style({image: new Icon({src: require("@/assets/images/ysqjc/hdB.png"),scale: 1,zIndex: 110,})}));
                            } else {
                                wzimage.setStyle(new Style({image: new Icon({src: require("@/assets/images/ysqjc/hdA.png"),scale: 1,zIndex: 110,})}));
                            }
                        } else {
                            wzimage.setStyle(new Style({image: new Icon({src: require("@/assets/images/ysqjc/hdA.png"),scale: 1,zIndex: 110,})}));
                        }
                    }

                    wzimage.set("stcd", n.stcd);
                    wzimage.set("data", n);
                    dtImage.getSource().addFeature(wzimage);
                    if(n.status === 0){
                        wzimage2.setStyle(new Style(
                            {image: new Icon({src: require("@/assets/yzt/abnormalNum.png"),scale: 1,zIndex: 110,anchor: [1.2, 1]})},
                        ));
                        dtImage.getSource().addFeature(wzimage2);
                    }
                });
            } else if (this.show.ztt == 'aqxx') {

                return;
            }


        },
        //鼠标点击事件
        addMapClick(){
            const _this = this;
            this.map.on("singleclick", function (e) {
                const pixelT = e.pixel;
                const feature = _this.map.forEachFeatureAtPixel(
                    pixelT,
                    function (fea) {
                        return fea;
                    }
                );
                //找到了要素
                if (feature) {
                    const container = document.getElementById("popupA");
                    const overlayA = new Overlay({
                        element: container,
                    });
                    _this.map.addOverlay(overlayA);
                    let zl = feature.get("zl");
                    let cz = feature.get("data");
                    if (cz) {
                        if (cz.stcd) {
                            _this.clickJcz(cz,zl);
                        }
                    }
                }else{
                    return;
                }
            });
        },
        addPointermove(){
            const _this = this;
            this.map.on('pointermove',function(e) {
                var pixel=_this.map.getEventPixel(e.originalEvent);
                var feature=_this.map.forEachFeatureAtPixel(
                    pixel,
                    function (feature) {
                        return feature;
                    }
                )
                if (feature) {
                    let zl = feature.get("zl");
                    if (zl) {
                        _this.isSp = true;
                    } else {
                        _this.isSp = false;
                    }

                    let stcd = feature.get("stcd");
                    if (stcd) {
                        _this.tckData = feature.get("data");
                        const container = document.getElementById("popupA");
                        const overlayA = new Overlay({
                            element: container,
                        });
                        _this.map.addOverlay(overlayA);
                        let coodinate = [_this.tckData.lgtd,_this.tckData.lttd];
                        overlayA.setPosition(coodinate);

                        _this.map.getTargetElement().style.cursor="pointer";
                        _this.isShow = true;
                    } else {
                        _this.map.getTargetElement().style.cursor="auto";
                        _this.isShow = false;
                    }
                } else {
                    _this.map.getTargetElement().style.cursor="auto";
                    _this.isShow = false;
                }
            })
        },
        //鼠标滚动事件
        addMapWheel() {
            this.gd = () => {
                this.showCzData();
            }
            this.map.addEventListener('moveend', this.gd, true);
        },
        showCzData(){
            let curLevel = this.map.getView().getZoom();
            if(curLevel >= 10.5){
                this.czname();
            } else {
                if (cz_img) {
                    cz_img.getSource().getFeatures().forEach(function(feature) {
                        if (!feature.style_) {
                            return;
                        }
                        if (feature.style_.text_) {
                            cz_img.getSource().removeFeature(feature);
                        }
                    });
                } else {
                    return;
                }
            }
        },
        czname(){
            if (this.map) {
                this.map.removeLayer(cz_img);
            }
            cz_img = new VectorLayer({
                source: new VectorSource(),
                visible: true,
                zIndex: 120,
            });
            this.map.addLayer(cz_img);
            for(let data of this.mapData){
                const ext = [parseFloat(data.lgtd), parseFloat(data.lttd)];
                const wzimage = new Feature(new Point(ext));
                wzimage.setStyle(
                    new Style(
                        {
                            text:new Text(
                                {
                                    text: '\r\r'+data.stnm+'\r',
                                    textAlign: "center",
                                    offsetY: 20,
                                    backgroundFill: new Stroke({
                                        color: 'rgba(44,131,234,0.8)',
                                    }),
                                    // 文本填充样式
                                    fill: new Fill({
                                        color: 'rgba(255,255,255,1)',
                                    }),
                                    scale: 1.5
                                }
                            )
                        }
                    )
                )
                wzimage.set("data", data);
                cz_img.getSource().addFeature(wzimage);
            }
            for(let data of this.szData){
                const ext1 = [parseFloat(data.lgtd), parseFloat(data.lttd)];
                const wzimage1 = new Feature(new Point(ext1));
                wzimage1.setStyle(
                    new Style(
                        {
                            text:new Text(
                                {
                                    text: '\r\r'+data.stnm+'\r',
                                    textAlign: "center",
                                    offsetY: 20,
                                    backgroundFill: new Stroke({
                                        color: 'rgba(44,131,234,0.8)',
                                    }),
                                    // 文本填充样式
                                    fill: new Fill({
                                        color: 'rgba(255,255,255,1)',
                                    }),
                                    scale: 1.5
                                }
                            )
                        }
                    )
                )
                wzimage1.set("data", data);
                cz_img.getSource().addFeature(wzimage1);
            }
            for(let data of this.tzData){
                const ext2 = [parseFloat(data.lgtd), parseFloat(data.lttd)];
                const wzimage2 = new Feature(new Point(ext2));
                wzimage2.setStyle(
                    new Style(
                        {
                            text:new Text(
                                {
                                    text: '\r\r'+data.stnm+'\r',
                                    textAlign: "center",
                                    offsetY: 20,
                                    backgroundFill: new Stroke({
                                        color: 'rgba(44,131,234,0.8)',
                                    }),
                                    // 文本填充样式
                                    fill: new Fill({
                                        color: 'rgba(255,255,255,1)',
                                    }),
                                    scale: 1.5
                                }
                            )
                        }
                    )
                )
                wzimage2.set("data", data);
                cz_img.getSource().addFeature(wzimage2);
            }
        },
        sxwz(){
            this.tableRowCheck = false
            if(this.show.ztt !== 'aqxx') {
                this.czValue = '';
                this.czOptions = [];
                this.rowCheck = null
                this.sksqCheckd = false
                if (this.map) {
                    let view = this.map.getView();
                    view.setZoom(this.zoomNum); // 重新设置地图放大倍数
                    view.setCenter(this.center, 'EPSG:4326'); // 重新设置中心点的坐标
                }
            }else {
                const position = {x: 980,y: 500,z: 735};
                this.animateCamera(position);
                if(this.tmpPoint){
                    this.tmpPoint.material.color.set('#3F00FF');
                    this.tmpPoint = null;
                }
              if(this.aqxxClickPoint){
                this.aqxxClickPoint.material.color.set('#3F00FF');
                this.aqxxClickPoint = null;
              }
            }
        },
        hqskdtxx(){
            this.request.get('/rm-bspecial/v1/list').then((res) => {
                if(res.ok){
                    this.skdtxx = res.data;
                    let skCd = localStorage.getItem("skCd") ? localStorage.getItem("skCd") : null;
                    for (let i = 0; i < this.skdtxx.length; i++) {
                        if (skCd == parseFloat(this.skdtxx[i].bh)) {
                            this.maplx = this.skdtxx[i].map;
                            this.zoomNum = parseFloat(this.skdtxx[i].level);
                            this.fdlevel = parseFloat(this.skdtxx[i].fdlevel);
                            this.center[0] = parseFloat(this.skdtxx[i].jd);
                            this.center[1] = parseFloat(this.skdtxx[i].wd);
                            break;
                        } else {
                            this.zoomNum = 4;
                            this.center = [103.95, 34.10];
                        }
                    }
                    this.initMap();
                    this.addDrawLayer();//添加绘图层
                    this.addMapClick();//鼠标点击事件
                    this.addPointermove();//鼠标移入事件
                    this.addMapWheel();//鼠标滚动事件
                    this.sethlLayer();//初始化河流图层
                }else{
                    this.$message.error(res.error.message)
                }
            });
        },
        czMap(){
            // :style="{width: show.right ? '80vw' : '100vw' }"
            let qwer = document.getElementById('olMap');
            let aqxxMap = document.getElementById('aqxxMap');

            if (this.show.right) {
                qwer.style.width = '80vw';
                aqxxMap.style.width = '80vw';
            } else {
                qwer.style.width = '100vw';
                aqxxMap.style.width = '100vw';
            }
            if(this.show.ztt === 'yqxx' || this.show.ztt === 'sqxx'){
                this.$nextTick(()=>{
                    this.map.updateSize();
                })

            }
            if(this.show.ztt === 'aqxx'){
              if(this.timeDiv) {
                const width = this.timeDiv.offsetWidth;
                const height = this.timeDiv.offsetHeight;
                camera.aspect = width / height;
                renderer.setSize(width, height);
                camera.updateProjectionMatrix();
                renderer.setPixelRatio(window.devicePixelRatio);
              }
            }
        },


        //地图工具类
        //清除绘制图层
        clearDrawLayer() {
            this.map.removeInteraction(this.draw); //移除交互
            this.draw_vector.getSource().clear(); //清除图层上的所有要素
            this.map.getOverlays().clear()
            //移除监听事件
            unByKey(this.pointermoveEvent) // 清除鼠标在地图的pointermove事件
            unByKey(this.geometryListener) // 清除绘制图像change事件
            this.pointermoveEvent = null;
            this.geometryListener = null;
            this.measureResult = "0";
            this.measureType = ""
        },
        //添加绘制点线面图层
        addDrawLayer() {
            this.draw_vector = new VectorLayer({
                source: this.draw_source,
                //绘制好后，在地图上呈现的样式
                style: new Style({
                    fill: new Fill({
                        color: "rgba(255, 255, 255, 0.2)",
                    }),
                    stroke: new Stroke({
                        //边界样式
                        color: "#ffcc33",
                        width: 3,
                    }),
                    //点样式继承image
                    image: new Circle({
                        radius: 7,
                        fill: new Fill({
                            color: "#ffcc33",
                        }),
                    }),
                }),
            });
            this.map.addLayer(this.draw_vector);

        },
        //画线点
        drawFeature(featureType){
            var geometryFunction;
            if(featureType === 'Box'){
                featureType = 'Circle';                       //绘制矩形需将value值设为Circle
                geometryFunction =createBox();             //绘制矩形
            }
            // 矢量图层
            /*   this.vectorLayer = new VectorLayer({
                   source: this.draw_source,
                   style: new Style({
                       fill: new Fill({
                           color: 'rgba(252, 86, 49, 0.1)'
                       }),
                       stroke: new Stroke({
                           color: '#fc5531',
                           width: 3
                       }),
                       image: new Circle({
                           radius: 0,
                           fill: new Fill({
                               color: '#fc5531'
                           })
                       })
                   }),
                   name: "测量图层"
               });
               this.map.addLayer(this.vectorLayer)*/
            this.draw = new Draw({
                source: this.draw_source,
                type: featureType,
                style: new Style({
                    fill: new Fill({
                        color: 'rgba(252, 86, 49, 0.1)'
                    }),
                    stroke: new Stroke({
                        color: '#fc5531',
                        lineDash: [10, 10],
                        width: 3
                    }),
                    image: new Circle({
                        radius: 0,
                        fill: new Fill({
                            color: '#fc5531'
                        })
                    })
                }),
                geometryFunction:geometryFunction,
                // 绘制时点击处理事件
                condition: (evt) => {
                    // 测距时添加点标注
                    if (this.measureResult != "0" && !this.map.getOverlayById(this.measureResult) && this.measureType == "distence")
                        this.creatMark(null, this.measureResult, this.measureResult).setPosition(evt.coordinate)
                    return true
                }
            });
            this.map.addInteraction(this.draw);
            /**
             * 绘制开始事件
             */
            this.draw.on("drawstart", e => {
                this.sketchFeature = e.feature
                let proj = this.map.getView().getProjection()
                //******距离测量开始时*****//
                if (this.measureType == "distence") {
                    this.creatMark(null, "起点", "start").setPosition(this.map.getCoordinateFromPixel(e.target.downPx_))
                    this.tipDiv.innerHTML = "总长：0 m</br>单击确定地点，双击结束";
                    this.geometryListener = this.sketchFeature.getGeometry().on('change', (evt) => {
                        this.measureResult = this.distenceFormat(getLength(evt.target, { "projection": proj, "radius": 6378137 }))
                        this.tipDiv.innerHTML = "总长：" + this.measureResult + "</br>单击确定地点，双击结束";
                    })
                }
                //******面积测量开始时*****//
                else if (this.measureType == "area") {
                    this.tipDiv.innerHTML = "面积：0 m<sup>2</sup></br>继续单击确定地点";
                    this.geometryListener = this.sketchFeature.getGeometry().on('change', (evt) => {
                        if (evt.target.getCoordinates()[0].length < 4) this.tipDiv.innerHTML = "面积：0m<sup>2</sup></br>继续单击确定地点";
                        else {
                            this.measureResult = this.formatArea(getArea(evt.target, { "projection": proj, "radius": 6378137 }))
                            this.tipDiv.innerHTML = "面积：" + this.measureResult + "</br>单击确定地点，双击结束";
                        }
                    })
                }
                //******角度测量开始时*****//
                else if (this.measureType == "angle") {
                    this.tipDiv.innerHTML = "继续单击确定顶点";
                    this.geometryListener = this.sketchFeature.getGeometry().on('change', (evt) => {
                        if (evt.target.getCoordinates().length < 3) this.tipDiv.innerHTML = "继续单击确定顶点";
                        else {
                            this.measureResult = this.formatAngle(evt.target)
                            this.tipDiv.innerHTML = "角度：" + this.measureResult + "</br>继续单击结束";
                        }
                    })
                }
            });
            /**
             * 绘制结束事件
             */
            this.draw.on("drawend", e => {
                let closeBtn = document.createElement('span');
                /* closeBtn.innerHTML = "×";
                 closeBtn.title = "清除测量"
                 closeBtn.style = "width: 10px;height:10px;line-height: 12px;text-align: center;border-radius: 5px;display: inline-block;padding: 2px;color: rgb(255, 68, 0);border: 2px solid rgb(255, 68, 0);background-color: rgb(255, 255, 255);font-weight: 600;position: absolute;top: -25px;right: -2px;cursor: pointer;";
                 closeBtn.addEventListener('click', () => {
                     this.clearMeasure()
                 })*/
                //******距离测量结束时*****//
                if (this.measureType == "distence") {
                    this.creatMark(closeBtn, null, "close1").setPosition(e.feature.getGeometry().getLastCoordinate());
                    this.creatMark(null, "总长：" + this.measureResult + "", "length").setPosition(e.feature.getGeometry().getLastCoordinate())
                    this.map.removeOverlay(this.map.getOverlayById(this.measureResult))
                }
                //******面积测量结束时*****//
                else if (this.measureType == "area") {
                    this.creatMark(closeBtn, null, "close2").setPosition(e.feature.getGeometry().getInteriorPoint().getCoordinates());
                    this.creatMark(null, "总面积：" + this.measureResult + "", "area").setPosition(e.feature.getGeometry().getInteriorPoint().getCoordinates())
                }
                //******角度测量结束时*****//
                else if (this.measureType == "angle") {
                    this.creatMark(closeBtn, null, "close3").setPosition(e.feature.getGeometry().getCoordinates()[1]);
                    this.creatMark(null, "角度：" + this.measureResult + "", "angle").setPosition(e.feature.getGeometry().getCoordinates()[1])
                }
                // 停止测量
                this.stopMeasure();
            });


            /*   let _this = this;
               this.draw.on("drawend",function (e) {
                   _this.map.removeInteraction(_this.draw); //移除交互
               })*/
        },
        //测量
        measure(type){
            this.measureType = type;
            if (this.vectorLayer != null) {
                this.clearMeasure();
            }
            this.tipDiv = document.createElement('div');
            this.tipDiv.innerHTML = '单击确定起点';
            this.tipDiv.className = "tipDiv";
            this.tipDiv.style = "width:auto;height:auto;padding:4px;border:1px solid #fc5531;font-size:12px;background-color:#fff;position:relative;top:60%;left:60%;font-weight:600;"
            let overlay = new Overlay({
                element: this.tipDiv,
                autoPan: false,
                positioning: "bottom-center",
                id: "tipLay",
                stopEvent: false //停止事件传播到地图
            });
            this.map.addOverlay(overlay);

            this.pointermoveEvent = this.map.on("pointermove", evt => {
                overlay.setPosition(evt.coordinate)
            })
            if (this.measureType == "distence" || this.measureType == "angle") {
                this.drawFeature("LineString")
            }
            else if (this.measureType == "area") {
                this.drawFeature("Polygon")
            }
        },
        //停止测量
        stopMeasure() {
            this.measureType = ''
            this.tipDiv = null
            this.map.removeInteraction(this.draw); // 移除绘制组件
            this.draw = null;
            this.map.removeOverlay(this.map.getOverlayById("tipLay")) // 移除动态提示框
        },
        //清除测量
        clearMeasure() {
            this.draw_source.getSource().clear()
            this.map.getOverlays().clear()
            //移除监听事件
            unByKey(this.pointermoveEvent) // 清除鼠标在地图的pointermove事件
            unByKey(this.geometryListener) // 清除绘制图像change事件
            this.pointermoveEvent = null;
            this.geometryListener = null;
            this.measureResult = "0"
        },
        //创建标记
        creatMark(markDom, txt, idstr) {
            if (markDom == null) {
                markDom = document.createElement('div');
                markDom.innerHTML = txt
                markDom.style = "width:auto;height:auto;padding:4px;border:1px solid #fc5531;font-size:12px;background-color:#fff;position:relative;top:60%;left:60%;font-weight:600;"
            }
            let overlay = new Overlay({
                element: markDom,
                autoPan: false,
                positioning: "bottom-center",
                id: idstr,
                stopEvent: false
            });
            this.map.addOverlay(overlay)
            return overlay;
        },
        //格式化距离结果输出
        distenceFormat(length) {
            let output;
            if (length > 100) {
                output = (Math.round(length / 1000 * 100) / 100) + ' ' + 'km'; //换算成km单位
            } else {
                output = (Math.round(length * 100) / 100) + ' ' + 'm'; //m为单位
            }
            return output;//返回线的长度
        },
        //格式化面积输出
        formatArea(area) {
            let output;
            if (area > 10000) {
                output = (Math.round(area / 1000000 * 100) / 100) + ' ' + 'km<sup>2</sup>'; //换算成km单位
            } else {
                output = (Math.round(area * 100) / 100) + ' ' + 'm<sup>2</sup>';//m为单位
            }
            return output; //返回多边形的面积
        },
        // 地图缩小
        zoomOut() {
            // 使用map对象获取view视图，然后设置View视图的放大，缩小参数即可
            const view = this.map.getView();
            const zoom = view.getZoom();
            view.setZoom(zoom - 1);
        },
        // 地图放大
        zoomIn() {
            const view = this.map.getView();
            const zoom = view.getZoom();
            view.setZoom(zoom + 1);
        },

        iconHadler({row, rowIndex}) {
            if(row.length===0){
                return 'icon-no el-table-frist';
            }else{
                return 'table1';
            }


        },
        /* 加入小手状态 */
        cellStyle(data) {
            if (data) {
                return 'cursor:default;'
            }
        },

        //调用数据接口，获取列表数据，根据自己情况填接口url
        bsGetProductProcess() {
            clearInterval(this.tableTimer);
            this.tableTop = 0;
            if (this.activeFactoryId != "") {
                this.request.post('/rm-tyjxx/queryYjxxList',{ yjzt: 0}).then((res) => {
                    if(res.ok){
                        this.tableList = res.data.records
                        this.yjList = res.data.records
                        if(this.tableList.length === 1){
                            this.tableList = this.tableList.concat(this.tableList.concat(this.tableList))
                        }else if(this.tableList.length === 2){
                            this.tableList = this.tableList.concat(this.tableList)
                        }
                        //  this.tableActionFun();
                    }
                })
            }
        },

        componentTimerFun() {
            this.bsGetProductProcess();
            this.initDataItem();
        },

    },
    mounted() {
        this.countDown()//定时器

        this.hqskdtxx();
        this.initDataItem();//初始化数据
        this.bsGetProductProcess();//初始化预警数据

        clearInterval(this.componentTimer);
        //this.componentTimerFun();
    },
    beforeDestroy() {
        clearInterval(this.componentTimer);
        clearInterval(this.tableTimer);
        clearTimeout(this.timer)
        if (this.requestID) {
            try {
                // camera.dispose();
                clearScene(scene);
                // scene.background.dispose();
                controls.dispose();
                this.mousePointer = null;
                scene.remove();
                scene.clear();
                scene = null;
                const gl = renderer.domElement.getContext('webgl');
                gl && gl.getExtension("WEBGL_LOSE_CONTEXT").loseContext();
                TWEEN.removeAll();
                this.raycaster = null;
                renderer.renderLists.dispose();
                renderer.dispose();
                renderer.forceContextLoss();
                renderer.domElement = null;
                renderer.content = null;
                camera = null;
                renderer = null;
                cancelAnimationFrame(this.requestID);
                THREE.Cache.clear();
                this.timeDiv.removeEventListener("click", this.aqxxPositionChange, true);
                this.timeDiv.removeEventListener("mousemove", this.onAqxxMouseMove, true);
            }catch (e){
                //console.log(e);
            }
        }
    },

    watch:{
        "$store.state.head.skName"(val,val1) {
            this.rowCheck = null
            this.sksqCheckd = false
            this.tableRowCheck = false

            this.skName = val;
            this.qhMap();
            this.selectd.aqxx = '0601'
            this.getData();
        },
        "$store.state.head.skCd"(val,val1) {
            this.skCd = val;
        },
    },

}
</script>

<style lang="less">
/* 注意此处没有添加scoped属性，所以全局生效，但是有类名限制，不会与其他类样式冲突 */
.table1{
    .el-table tr {
        background-color: #f31212;
    }
}
</style>

<style scoped>
.ellipse {
    width: 22rem;        /* 椭圆的宽度 */
    height: 50rem;       /* 椭圆的高度 */
    border-radius: 50%;  /* 边框半径为50%，形成圆形，进而形成椭圆 */
    border: 1px solid #82bbff;
    position: absolute;
    transform: translate(-50%,-50%);
    top: 50%;
    z-index: 2;
}
.czjz{
    position: absolute;
    transform: translate(-50%,-50%);
    top: 50%;
    left: 50%;
}
.pointer{
    cursor: pointer;
}
.dzxdzm{
    border: 1px solid #e8ecff;
    border-radius: 4px;
    width: 299px;
    height: 46px;
    font-size: 16px;
    /* background: #3a8ee6; */
    text-align: center;
    line-height: 46px;
    position: absolute;
    right: 58rem;
    z-index: 12;
}
.tcSelect{
    position: absolute;
    bottom: 100px;
    right: 20px;
    box-sizing: border-box;
    border: 1px solid #e8ecff;
    border-radius: 4px;
    line-height: 40px;
    font-size: 16px;
    z-index: 12;
    background-color: #fff;
}
.tcSelectz{
    width: 120px;
    height: 130px;
    padding-left: 20px;
}
.aqxxSelect{
    border: 1px solid #e8ecff;
    border-radius: 4px;
    width: 599px;
    height: 46px;
    font-size: 16px;
    /* background: #3a8ee6; */
    text-align: center;
    line-height: 46px;
    position: absolute;
    right: 45rem;
    z-index: 12;
}
.xzsj1{
    border: 1px solid #e8ecff;
    border-radius: 6px;
    width: 85%;
    height: 40px;
    font-size: 16px;
    background: #e8ecff;
    text-align: center;
    line-height: 40px;
    float: right;
}
.xzsj2{
    border-radius: 6px;
    width: 100%;
    height: 40px;
    font-size: 16px;
    text-align: center;
    line-height: 40px;
    float: right;
}
.buttonSeletd{
    color: #ffffff;
    background-color: #3387e9 !important;
    border-radius: 0.9rem;
}

.sdbutton{
    float: left;
    width: 99px;
}
.sjbutton1{
    float: left;
    width: calc(100% / 5);
}
.sjbutton2{
    float: left;
    background-color: #e8ecff;
    width: calc(50% - 8px);
    border-radius: 6px;
}

/deep/ .el-range-input {
    color: #41427b;
    background-color: #e8ecff;
    font-size: 1.5rem;
}

/* 地图样式 */
.map {
    position: relative;
    height: 100vh;
    width: 80vw;
}
::v-deep .ol-zoom{
    display:none;
}
/deep/ ::-webkit-scrollbar {
    width: 6px;
    height: 6px;
}
/deep/ ::-webkit-scrollbar-track {
    --webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
    border-radius: 6px;
}
/deep/ ::-webkit-scrollbar-thumb {
    border-radius: 3px;
    background: rgb(220, 220, 220);
    --webkit-box-shadow: inset 0 0 3px rgba(0,0,0,0.5);
}
/deep/ ::-webkit-scrollbar-thumb:window-inactive {
    background: rgba(220,220,220,0.4);
}
::v-deep .aqxx-table .el-table__body-wrapper::-webkit-scrollbar {
    height: 14px;
}
::v-deep .aqxx-table .el-table__body-wrapper::-webkit-scrollbar-thumb {
    border-radius: 7px;
    background: rgb(190, 190, 190);
}
::v-deep .icon-no .el-table__expand-icon {
    background-color:#FF1010;
    display: none;
}
.el-table-frist .el-table__cell .cell {
    padding: 0;
}
::v-deep .myrow{
    .hover-row,
    td {
        background: transparent !important;
    }
}
::v-deep .myrow:hover {
    background:#F5F7FA !important;
}

/deep/ .el-table .el-table-double {
    background: #f7f7f7;
}

/* 地图弹框样式 */
.ol-popup {
    position: absolute;
    bottom: 20px;
    left: 20px;
    min-width: 256px;
    height: 40px;
    background-color: #2c83ea;
    font-family: "PingFang SC";
    color: #FFFFFF;
    border: 2px solid #fff;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
}
.ol-popupSp {
    position: absolute;
    bottom: 5px;
    left: 15px;
    min-width: 256px;
    height: 40px;
    background-color: #2c83ea;
    font-family: "PingFang SC";
    color: #FFFFFF;
    border: 2px solid #fff;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
}
.marquee {
    width: 100%;
    /* height: 200px; */
    align-items: center;
    color: #fafbfa;
    display: flex;
    box-sizing: border-box;
    overflow: hidden;
}
.marquee_list li {
    height: 30px;
    line-height: 30px;
    font-size: 14px;
    padding-left: 20px;
}
.marquee_list li span {
    padding: 0 2px;
}
.title_div {
    width: 100%;
}
.table_body {
    width: 100%;
//margin-top: 15px;
}
.table_th {
    width: 100%;
    display: flex;
    height: 40px;
    line-height: 40px;
}
.tr {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    box-sizing: border-box;
    padding: 0 20px;
    text-align: center;
    font-size: 14px;
}
.tr1 {
    width: 100%;
}
.table_main_body {
    width: 100%;
    height: 5rem;
    overflow: hidden;
    position: relative;
}
.table_inner_body {
    width: 100%;
    position: absolute;
    left: 0;
}
.table_tr {
    display: flex;
    height: 40px;
    line-height: 40px;
    color: #eee;
    font-size: 15px;
//background: rgba(255, 255, 255, 0.1);
//border: 1px solid rgb(255, 255, 255);
    margin-top: 7px;
}
.yjactive{
    height: 49px;
    line-height: 40px;
    color: #eee;
    font-size: 15px;
    background: rgba(255, 255, 255, 0.1);
    cursor: default;
    overflow: hidden;
    white-space: nowrap;
    padding: 0 5px;
    text-align: center;
}
.bs-sysMsg {
    position: relative;
    display: flex;
    width: 100%;
    padding: 8px 12px;
    margin-bottom: 10px;
    border-radius: 2px;
    color: #e6a23c;
    background-color: #fdf6ec;
    overflow: hidden;
    opacity: 1;
    align-items: center;
    transition: opacity .2s;
}
.bs-sysMsg .msg__content {
    display: table-cell;
    padding: 0 8px;
    width: 100%;
}
.bs-sysMsg .msg__content a.item {
    color: #e6a23c;
    font-size: 14px;
    opacity: 0.75;
}
.bs-sysMsg .msg__content a.item:hover{text-decoration: underline;}
/deep/.el-table__body tr.current-row > td {
    background-color: #ECF5FF;
}
.divClick{
    background-color: #ECF5FF !important;
}
/deep/ body .el-table th.gutter {
    display: table-cell !important;
}
/deep/ body .el-table colgroup.gutter {
    display: table-cell !important;
}


/deep/ .el-radio {
    margin-right: 0px;
}
</style>
